const en = {
  FEBRUARY: 'FEBRUARY',
  JANUARY: 'JANUARY',
  JULY: 'JULY',
  JUNE: 'JUNE',
  MARCH: 'MARCH',
  Pin_External: 'Pin external',
  Pin_Internal: 'Pin internal',
  accountNotVerriyed: 'Account not verified',
  accountNotYetActivated: 'Your account has not yet been activated',
  assistance_as_needed: 'Assistance',
  automatic: 'Automatic',
  backward: 'Backward',
  block: 'Lock edition',
  allDevices: 'All devices',
  totalSteps: 'Total steps',
  selectPeriod: 'Show data for',
  lastMonthFilter: 'Last month',
  rankingStepsByUser: 'Ranking steps by user',
  unknownUser: 'Unknown User',
  unknownOrg: 'Unknown Organization',
  checkEmail: 'Please contact your administrator to activate your account.',
  clear: 'Clear',
  close: 'Close',
  days: 'days',
  dashboard: 'Main Panel',
  dateRange: ' Select date range',
  deleteDevice: 'Delete device',
  deleteInstitution: 'Delete organization',
  deletePatient: 'Delete patient',
  deleteUser: 'Delete user',
  doPremium: 'Do you want to go premium?',
  doPremiumDescription: 'You can access all the features of the premium plan.',
  edit: 'Enable edition',
  emptyAlarms: 'The device has no alarms',
  emptyMessage: 'No data to display',
  emptyValuesTable: 'No values to show...',
  errorForms: 'There are errors in the form',
  forward: 'Forward',
  goBack: 'Go back',
  loading: 'Loading...',
  noResults: 'No results',
  validations: {
    required: 'Required field',
  },
  goHome: 'Go to dashboard',
  institution: 'Organization',
  intention: 'Triggering by force',
  july: 'July',
  june: 'June',
  messages: {
    confirm: 'Confirm',
    cant_use_device: 'You cannot use this device',
    changing_password: 'Changing password, please wait...',
    contact: 'Please try again later. If the problem persists, contact ',
    dashboards: {
      create_dashboard: 'Dashboard created successfully',
      dashboard_created_error: 'Error creating the dashboard',
    },
    surveys: {
      create_survey: 'Survey created successfully',
      survey_created_error: 'Error creating the survey',
      survey_paused_success: 'Survey paused successfully',
      survey_paused_error: 'Error pausing the survey',
      survey_resumed_success: 'Survey resumed successfully',
      survey_resumed_error: 'Error resuming the survey',
      survey_sended_success: 'Survey sent successfully',
      survey_sended_error: 'Error sending the survey',
      recipients_added_success: 'Recipients added successfully',
      recipients_added_error: 'Error adding recipients',
      recipients_deleted_success: 'Recipients deleted successfully',
      recipients_deleted_error: 'Error deleting recipients',
      draft_saved_success: 'Draft saved successfully',
      draft_saved_error: 'The draft could not be saved. Please try again.',
      draft_load_error: 'The draft could not be loaded.',
      draft_deleted_error: 'The draft could not be deleted. Please try again.',
    },
    devices: {
      confirm_delete_device: 'Are you sure you want to delete this device?',
      add_device_to_org_error: 'Error adding the device to the organization',
      add_device_to_org_success: 'Device added to the organization',
      create_device: 'Device created successfully',
      delete_device_error: 'Error deleting the device',
      delete_device_from_org_error:
        'Error removing the device from the organization',
      delete_device_from_org_success: 'Device removed from the organization',
      delete_device_success: 'Device deleted successfully',
      device_created_error: 'Error creating the device',
      device_not_exists: 'This device does not exist',
      device_updated_error: 'Error updating the device',
      unique_serial_error: 'The serial number is already in use',
      update_device: 'Device updated successfully',
    },
    email_already_in_use: 'Email already in use',
    error: 'Error',
    error_ingestion: 'Error processing the ingestion, the ingestion is corrupt',
    error_message: 'Something went wrong',
    registerSuccess:
      'Registration successful. Please check your email to verify your account.',
    incidence: {
      create: 'Incident created successfully',
      create_error: 'Error creating the incident',
      close: 'Incident closed successfully',
      close_error: 'Error closing the incident',
    },
    info: 'Info',
    loading: 'Loading',
    ingestion: {
      dowload_multiple_files_error: 'Error downloading multiple files',
      dowload_multiple_files_success: 'Files downloaded successfully',
      download_multiple_files: 'Downloading multiple files',
      empty_file: 'Empty file',
      error_downloading: 'Error downloading the file',
      success_donwload: 'File downloaded successfully',
      payload_too_large:
        'File too large. Please contact support for more information.',
    },
    invalidDate: 'Invalid date',
    login: {
      error: 'Incorrect username and/or password',
      ip_blocked:
        'Too many failed login attempts from this IP. Please wait for the following minutes before trying again: ',
      account_permanent_block:
        'User permanently blocked. Please contact the administrators',
      account_blocked:
        'Your account has been locked due to too many failed login attempts. Please wait for the following minutes before trying again: ',
      account_pending: 'Your account is pending verification',
      account_not_active:
        'Your account is pending activation by the organization administrator',
      unexpected_error: 'An unexpected error occurred during the login process',
    },
    o_id_not_found: 'Device code not found',
    maintenance_orders: {
      create: 'Maintenance order created successfully',
      create_error: 'Error creating the maintenance order',
      assign_error: 'Error assigning the maintenance order',
    },
    org: {
      add_device_error: ' Error adding the device to the organization',
      create_org: 'Organization created successfully',
      create_org_error: 'Error creating the organization',
      delete_org: 'Organization deleted successfully',
      delete_org_error: 'Error deleting the organization',
      error_fetching_org_data: 'Error fetching organization data',
      premium_error: 'Error updating the premium status',
      premium_success: 'Premium status updated successfully',
      update_org: 'Organization updated successfully',
      update_org_error: 'Error updating the organization',
      update_creator_success: 'Creator updated successfully',
      update_creator_error: 'Error updating the creator',
    },
    patient: 'Patient',
    patient_modified_error: 'Error modifying the patient',
    patient_modified_success: 'Patient modified',
    report: {
      downloading: 'Please wait while the file is downloading...',
      success: 'Report generated successfully',
    },
    success: 'Success',
    success_message: 'Operation completed successfully',
    update_share_error: 'Error updating the data',
    update_share_success: 'Data updated successfully',
    user: {
      active_error: 'Error activating the user',
      user_created_error: 'Error creating the user',
      user_created_success: 'User created successfully',
      user_updated_error: 'Error updating the user',
      user_updated_success: 'User updated successfully',
    },
    warning: 'Warning',
    authentication_required: 'Authentication required',
    access_denied:
      'Access denied. Only maintenance users can access this feature.',
    access_denied_admin:
      'Access denied. Only admin users can access this feature.',
    error_uploading_firmware: 'Error uploading firmware',
  },
  my_profile: {
    copy: 'Copy',
    copied: 'Copied',
    blockOrganizationData:
      "Do you want to stop sharing your organization's data?",
    blockPersonalData: 'Do you want to stop sharing your personal data?',
    changePassword: 'Change password',
    confirmOrganizationTitle: "Changes to your organization's data privacy",
    confirmPassword: 'Confirm your new password : ',
    confirmPersonalTitle: 'Changes to your personal data privacy',
    confirmchangepassword: 'Change password successfully',
    disablePrivacyField: 'Do you want to disable this privacy option?',
    enablePrivacyField: 'Do you want to enable this privacy option?',
    errorchangepassword: 'Error the password won´t change',
    hide: 'Hide',
    incorrectpassword: 'Incorrect password:',
    nationality: {
      afghan: 'Afghan',
      argentine: 'Argentine',
      australian: 'Australian',
      austrian: 'Austrian',
      brazilian: 'Brazilian',
      british: 'British',
      canadian: 'Canadian',
      chilean: 'Chilean',
      chinese: 'Chinese',
      colombian: 'Colombian',
      cuban: 'Cuban',
      danish: 'Danish',
      dutch: 'Dutch',
      egyptian: 'Egyptian',
      english: 'English',
      filipino: 'Filipino',
      finnish: 'Finnish',
      french: 'French',
      german: 'German',
      greek: 'Greek',
      indian: 'Indian',
      irish: 'Irish',
      italian: 'Italian',
      japanese: 'Japanese',
      korean: 'Korean',
      mexican: 'Mexican',
      moroccan: 'Moroccan',
      new_zealander: 'New Zealander',
      nigerian: 'Nigerian',
      norwegian: 'Norwegian',
      peruvian: 'Peruvian',
      polish: 'Polish',
      portuguese: 'Portuguese',
      romanian: 'Romanian',
      russian: 'Russian',
      saudi: 'Saudi',
      scottish: 'Scottish',
      south_african: 'South African',
      spanish: 'Spanish',
      swedish: 'Swedish',
      swiss: 'Swiss',
      thai: 'Thai',
      turkish: 'Turkish',
      ukrainian: 'Ukrainian',
      uruguayan: 'Uruguayan',
      venezuelan: 'Venezuelan',
      vietnamese: 'Vietnamese',
    },
    newPassword: 'New password:',
    oldPassword: 'Old password:',
    organizationData: "Do not share my organization's data",
    passwordDifferentFromOld: 'The new password must be different from the current one.',
    personalData: "Don't share my personal data",
    privacyDataTitle: 'Changes to your privacy preferences',
    title: 'My account',
    titlechangepassword: 'Change password ',
    unblockOrganizationData:
      "Do you want to start sharing your organization's data again?",
    unblockPersonalData: 'Do you want to start sharing your personal data again?',
    update_error: 'Error updating information',
    update_success: 'Updated data',
  },
  no: 'No',
  noData: 'No data',
  noSessionDevice: 'No sessions for this device',
  numberOfSteps: 'Number of steps',
  optional: 'Optional',
  pageNotFound: 'Page not found',
  pageNotFoundDescription: "Sorry, we couldn't find the page.",
  pages: {
    alarms: {
      active: 'Active',
      alarms: {
        1: 'Manual joint calibration test',
        2: 'Automatic joint calibration test',
        3: 'Manual calibration test for the elevation motor',
        4: 'Chair calibration test',
        5: 'Full functional test',
        6: 'Enable and disable alarms test',
        7: 'Updates the calibration values of the load cell with the value read by the ADC',
        8: 'Manual introduction test for the calibration of each motor',
        9: 'Manually enter the sensor calibration of 0',
        10: 'Calibration IMU',
        11: ' Automatic calibration of the zero sensor',
        501: 'Emergency stop button pressed',
        502: 'No data',
        503: 'Main battery charge level is low',
        504: 'The main battery charge level is critically low',
        505: 'Main battery temperature is critically high',
        506: 'No data',
        507: 'The device\'s posture is neither "Sitting" nor "Standing"',
        508: 'Communication between PCS and SCS has been lost',
        509: 'Communication between EPOS 1 and PCS has been los',
        510: 'Communication between EPOS 2 and PCS has been lost',
        511: 'Communication between EPOS 3 and PCS has been lost',
        512: 'Communication between EPOS 4 and PCS has been lost',
        513: 'No data',
        514: 'No data',
        515: 'Fault signal activated on EPOS 1',
        516: 'Fault signal activated on EPOS 2',
        517: 'Fault signal activated on EPOS 3',
        518: 'Fault signal activated on EPOS 4',
        519: 'No data',
        520: 'No data',
        521: 'No data',
        522: 'No data',
        523: 'Error in motor controller 1 (LH)',
        524: 'Error in motor controller 2 (RH)',
        525: 'Error in motor controller 3 (LK)',
        526: 'Error in motor controller 4 (RK)',
        527: 'No data',
        528: 'No data',
        529: 'No data',
        530: 'No data',
        531: 'Excessive temperature in EPOS 1 (LH).',
        532: 'Excessive temperature in EPOS 2 (RH)',
        533: 'Excessive temperature in EPOS 3 (LK)',
        534: 'Excessive temperature in EPOS 4 (RK)',
        535: 'Excessive temperature in motor 1 (LH)',
        536: 'Excessive temperature in motor 2 (RH)',
        537: 'Excessive temperature in motor 3 (LK)',
        538: 'Excessive temperature in motor 4 (RK)',
        539: 'Excessive current consumption in motor 1 (LH)',
        540: 'Excessive current consumption in motor 2 (RH)',
        541: 'Excessive current consumption in motor 3 (LK)',
        542: 'Excessive current consumption in motor 4 (RK)',
        543: 'No data',
        544: 'No data',
        545: 'No data',
        546: 'No data',
        547: 'Excessive torque measured in motor 1 (LH)',
        548: 'Excessive torque measured in motor 2 (RH)',
        549: 'Excessive torque measured in motor 3 (LK)',
        550: 'Excessive torque measured in motor 4 (RK)',
        551: 'No data',
        552: 'No data',
        553: 'No data',
        554: 'No data',
        555: 'Position mismatch between reference and sensor 1 in motor 1 (LH)',
        556: 'Position mismatch between reference and sensor 1 in motor 2 (RH)',
        557: 'Position mismatch between reference and sensor 1 in motor 3 (LK)',
        558: 'Position mismatch between reference and sensor 1 in motor 4 (RK)',
        559: 'Incorrect position in the Orbis sensor in motor 1 (LH).',
        560: 'Incorrect position in the Orbis sensor in motor 2 (RH).',
        561: 'Incorrect position in the Orbis sensor in motor 3 (LK)',
        562: 'Incorrect position in the Orbis sensor in motor 4 (RK)',
        563: 'Communication lost between the device and the application',
        564: 'Chair position incorrect in sit down/stand up movement',
        565: "The elevation motor's height is greater than the maximum height",
        566: "The elevation motor's height is lower than the minimum height",
        567: 'The elevation motor is moving when it is disabled or moving in the wrong direction',
        568: 'The exoskeleton is not following the target angles during the sit-down movement',
        569: 'The processor temperature is too high',
        570: 'Vrefint too low',
        571: 'Vrefint too high',
        572: 'The electronic box temperature is too high',
        573: 'PEB power board not detected',
        574: 'The exoskeleton is not detected as connected to the walking frame',
        575: "The walker's interlock signal is low",
        576: 'Interlock wheels signal is low',
        577: 'Pwrgood_24v is low',
        578: 'Pwrgood_5v is low',
        579: 'Pwrgood_exo signal is low when the exo is enabled',
        580: 'Pwrgood_wf signal is low when the walking frame is enabled',
        581: 'Pwrgood_wheels signal is low when the wheels are enabled',
        582: 'Pwrgood_exo signal is high before enabling exo',
        583: 'Pwrgood_wf signal is high before enabling walking frame',
        584: 'Pwrgood_wheels signal is high before enabling wheels',
        585: 'Reference out of software limits in motor 1 (LH)',
        586: 'Reference out of software limits in motor 2 (RH)',
        587: 'Reference out of software limits in motor 3 (LK)',
        588: 'Reference out of software limits in motor 4 (RK)',
        589: 'Mille position out of software limits in motor 1 (LH)',
        590: 'Mille position out of software limits in motor 2 (RH)',
        591: 'Mille position out of software limits in motor 3 (LK)',
        592: 'Mille position out of software limits in motor 4 (RK)',
        593: 'Excessive positional travel in motor 1 (LH)',
        594: 'Excessive positional travel in motor 2 (RH)',
        595: 'Excessive positional travel in motor 3 (LK)',
        596: 'Excessive positional travel in motor 4 (RK)',
        597: 'Elevation motor out of position for movement',
        598: 'Invalid patient parameters',
        599: 'EPOS initialization error',
        600: 'Incorrect height sensor reading',
        601: 'The height sensor or the elevation motor is not functioning',
        602: 'Attempt to switch from standing mode to wheelchair mode, or vice versa',
        603: "The StatusWord of EPOS 1 (LH) does not match the active motors' state",
        604: "The StatusWord of EPOS 2 (RH) does not match the active motors' state",
        605: "The StatusWord of EPOS 3 (LK) does not match the active motors' state",
        606: "The StatusWord of EPOS 4 (RK) does not match the active motors' state",
        607: 'Hip blockage detected',
        608: 'Seat blockage detected',
        609: 'Movement detected in the hips',
        610: 'Movement detected in the seat',
        611: 'Lost communication with the battery management system',
        612: 'Dangerous pressure detected on the ground',
        613: 'Position mismatch between the  sensor 1 and the sensor 2 in motor 1 (LH)',
        614: 'Position mismatch between the sensor 1 and the sensor 2 in motor 2 (RH)',
        615: 'Position mismatch between the sensor 1 and the sensor 2 in motor 3 (LK)',
        616: 'Position mismatch between the sensor 1 and the sensor 2 in motor 4 (RK)',
        617: 'Operating mode in EPOS 1 is not as expected',
        618: 'Operating mode in EPOS 2 is not as expected',
        619: 'Operating mode in EPOS 3 is not as expected',
        620: 'Operating mode in EPOS 4 is not as expected',
        621: 'Motor 1 is not available to move when entering a state that requires it',
        622: 'Motor 2 is not available to move when entering a state that requires it',
        623: 'Motor 3 is not available to move when entering a state that requires it',
        624: 'Motor 4 is not available to move when entering a state that requires it',
        625: 'The MCS version is not the same in all EPOS',
        626: 'The chair is deployed while walking',
        627: 'The zero sensor offset is above the limit',
        628: 'The number of steps allowed to calibrate the zero sensor has been exceeded',
        629: 'The chair angle is above the limit',
      },
      alarmsAtlas: {
        501: 'Emergency stop button pressed.',
        502: 'A flash memory error was detected.',
        503: 'The main battery charge level is low.',
        504: 'The main battery charge level is critically low.',
        505: 'The main battery temperature is critically high.',
        506: 'The auxiliary battery is critically low.',
        507: "The device's posture is different from 'Sitting' or 'Standing'. If you are going to walk, the legs should be straight with angles close to 0º. If sitting, the legs should form an angle of approximately 90º.",
        508: 'Communication was lost between the SCB and the MPB.',
        509: 'Communication was lost between MCB 1 and MPB.',
        510: 'Communication was lost between MCB 2 and MPB.',
        511: 'Communication was lost between MCB 3 and MPB.',
        512: 'Communication was lost between MCB 4 and MPB.',
        513: 'Communication was lost between MCB 5 and MPB.',
        514: 'Communication was lost between MCB 6 and MPB.',
        515: 'Error during autotest on MCB 1 electronic board.',
        516: 'Error during autotest on MCB 2 electronic board.',
        517: 'Error during autotest on MCB 3 electronic board.',
        518: 'Error during autotest on MCB 4 electronic board.',
        519: 'Error during autotest on MCB 5 electronic board.',
        520: 'Error during autotest on MCB 6 electronic board.',
        521: 'Class B variable failure in MPB.',
        522: 'Not all MCBs are ready.',
        523: 'Motor controller board 1 (ABD I) error. The device must be turned off and on again.',
        524: 'Motor controller board 2 (CI) error. The device must be turned off and on again.',
        525: 'Motor controller board 3 (RI) error. The device must be turned off and on again.',
        526: 'Motor controller board 4 (TI) error. The device must be turned off and on again.',
        527: 'Motor controller board 5 (ABD D) error. The device must be turned off and on again.',
        528: 'Motor controller board 6 (CD) error. The device must be turned off and on again.',
        529: 'Motor controller board 7 (RD) error. The device must be turned off and on again.',
        530: 'Motor controller board 8 (TD) error. The device must be turned off and on again.',
        531: 'Excessive temperature in motor 1 (ABD I). The device must be turned off and allowed to cool before using again.',
        532: 'Excessive temperature in motor 2 (CI). The device must be turned off and allowed to cool before using again.',
        533: 'Excessive temperature in motor 3 (RI). The device must be turned off and allowed to cool before using again.',
        534: 'Excessive temperature in motor 4 (TI). The device must be turned off and allowed to cool before using again.',
        535: 'Excessive temperature in motor 5 (ABD D). The device must be turned off and allowed to cool before using again.',
        536: 'Excessive temperature in motor 6 (CD). The device must be turned off and allowed to cool before using again.',
        537: 'Excessive temperature in motor 7 (RD). The device must be turned off and allowed to cool before using again.',
        538: 'Excessive temperature in motor 8 (TD). The device must be turned off and allowed to cool before using again.',
        539: 'Excessive current consumption in motor 1 (ABD I).',
        540: 'Excessive current consumption in motor 2 (CD).',
        541: 'Excessive current consumption in motor 3 (RI).',
        542: 'Excessive current consumption in motor 4 (TI).',
        543: 'Excessive current consumption in motor 5 (ABD D).',
        544: 'Excessive current consumption in motor 6 (CD).',
        545: 'Excessive current consumption in motor 7 (RD).',
        546: 'Excessive current consumption in motor 8 (TD).',
        547: 'Excessive torque measured in motor 1 (ABD I).',
        548: 'Excessive torque measured in motor 2 (CI).',
        549: 'Excessive torque measured in motor 3 (RI).',
        550: 'Excessive torque measured in motor 4 (TI).',
        551: 'Excessive torque measured in motor 5 (ABD D).',
        552: 'Excessive torque measured in motor 6 (CD).',
        553: 'Excessive torque measured in motor 7 (RD).',
        554: 'Excessive torque measured in motor 8 (TD).',
        555: 'Misalignment between Hall sensor and absolute sensor in motor 1 (ABD I).',
        556: 'Misalignment between Hall sensor and absolute sensor in motor 2 (CI).',
        557: 'Misalignment between Hall sensor and absolute sensor in motor 3 (RI).',
        558: 'Misalignment between Hall sensor and absolute sensor in motor 4 (TI).',
        559: 'Misalignment between Hall sensor and absolute sensor in motor 5 (ABD D).',
        560: 'Misalignment between Hall sensor and absolute sensor in motor 6 (CD).',
        561: 'Misalignment between Hall sensor and absolute sensor in motor 7 (RD).',
        562: 'Misalignment between Hall sensor and absolute sensor in motor 8 (TD).',
        563: 'Communication lost between the device and the application.',
      },
      date: 'Date and time',
      details: 'Details',
      eventId: 'Event id',
      eventType: 'Event type',
      inProgress: 'In Progress',
      inactive: 'Inactive',
      ingest: 'Data ingestion',
      message: 'Message',
      noAlarms: 'No alarms available',
      noParams: 'No parameters',
      params: ' Parameters',
      pending: 'Pending',
      search: 'Search by alarm code or type',
      solved: 'Solved',
      status: 'Status',
      value: 'Value',
      version: 'Version',
    },
    verifyAccount: {
      pendingTitle: 'Verifying account...',
      pendingDescription:
        'We are verifying your account. Please wait a few seconds.',
      verifyButton: 'Verify account',
      activatedTitle: 'Account verified',
      verified: 'Your account has been successfully verified.',
      errorTitle: 'Verification error',
      error:
        'We could not verify your account. The link may be invalid or may have expired.',
      alreadyActivated:
        'If your account was already activated, you can sign in normally.',
      backToLogin: 'Back to login',
    },
    welcometemplate: {
      title: 'You can now access MarsiNet!',
      description:
        'Your account has been successfully activated. We are delighted to have you with us to transform rehabilitation through technology.',
      welcomeButton: 'Access my account',
      errorSupport:
        'If you did not request this account, please contact support.',
      welcomeSubject: 'Welcome to Marsinet Family!',
    },
    registerAccount: {
      registerTitle: 'Account registered!',
      registerDescription:
        'Your account has been registered successfully. An administrator must now activate it before you can sign in. Please check your Spam folder.',
      backToLogin: 'Go to Login',
      messageExpired:
        'The link has already been used or has expired. If you have already verified your email, wait for the administrator to activate it.',
    },
    support: {
      confirmationTitle: 'Support request confirmation',
      greeting: 'Hello {{name}},',
      confirmationMessage:
        'We have successfully received your support request. Our team will review it as soon as possible.',
      ticketId: 'Request ID',
      issueType: 'Issue type',
      messageLabel: 'Message',
      viewRequestButton: 'View request',
      responseInfo:
        'We will get back to you as soon as we review the submitted information.',
      extraInfo:
        'If you need to add more details, you can reply to this email or contact our support team.',
      internalTitle: 'New support issue',
      internalHeading: 'New support request received',
      internalDescription: 'A new issue has been generated from the platform.',
      userName: 'User name',
      userEmail: 'User email',
      reserved: '© Marsi Bionics. All rights reserved.',
      footer: 'This is an automatic message from the Marsinet system.',
    },
    resetPassword: {
      title: 'Reset your password',
      back: 'Back to sign in',
      greeting: 'Hello {{name}},',
      description:
        'We have received a request to reset your account password. Click the button below to continue with the process.',
      button: 'Reset password',
      note: 'If you did not request this change, you can ignore this email. Your current password will remain valid until you complete the process.',
      footer: 'This is an automatic message from the Marsinet system.',
      password: 'New password',
      confirmPassword: 'Confirm new password',
      passwordChanged: 'Password reset successfully',
      errorChangingPassword: 'Error resetting password',
      reset: 'Reset password',
      success: 'Password reset successfully',
      confirmPasswordMatch: 'Passwords do not match',
    },
    admin: {
      pendingUsersTitle: 'New users pending activation',
      pendingUsersGreeting: 'Hello {{name}},',
      pendingUsersDescription:
        'There are new users pending activation in your organization. Access the user panel to review and activate them if appropriate.',
      pendingUsersButton: 'Go to pending users',
      footer: 'This is an automatic message from the Marsinet system.',
    },
    devices: {
      activate: 'Are you sure you want to activate the device',
      activateHeader: 'Activate',
      activatesDevices: 'Active devices',
      add: 'New device',
      app_version: 'App Version',
      battery_cycles: 'Battery cycles',
      ceb_version: 'CEB Version',
      code: 'Device Code',
      codeInvalid: 'Organization Code is not valid',
      codeInvalidCharacters: 'Device Code must not contain special characters',
      codeRequired: 'Organization Code is required',
      desactivate: 'Are you sure you want to deactivate the device',
      desactivateHeader: 'Desactivate',
      desactivatesDevices: 'Inactive Devices',
      deviceNumber: 'Device number',
      deviceNumberInvalid: 'Device number is not valid',
      deviceNumberInvalidCharacters:
        'Device number must not contain special characters',
      devicePage: {
        institution: 'Add device to organization',
        notEvents: 'There are no events for this device',
        notInstitution: 'Not assigned to any client organization',
        serial: 'Serial',
        tabEvents: 'Device events',
        tabInfo: 'Device information',
        type: 'Type',
      },
      epos_version: 'EPOS Version',
      esp_version: 'ESP Version',
      mcb_version: 'MCB Version',
      model: 'Model',
      modelInvadidCharacters: 'Model must not contain special characters',
      modelInvalid: 'Model is not valid',
      modelInvalidCharacters: 'Model must not contain special characters',
      modelRequired: 'Model is required',
      model_required: 'Model is required',
      mpb_version: 'MPB Version',
      nameRequired: 'Name is required',
      num_serial: 'Serial number',
      num_serial_required: 'Serial number is required',
      o_id: 'Organization ID',
      o_id_invalid: 'Organization ID is not valid',
      o_id_invalid_characters:
        'Organization ID must not contain special characters',
      o_id_required: 'Organization ID is required',
      optional_field: '(optional)',
      organization: 'Organization',
      password: 'Password',
      password_invalid: 'Password is not valid',
      password_invalid_characters:
        'Password must not contain special characters',
      password_required: 'Password is required',
      scb_version: 'SCB Version',
      selectStatus: 'Select status',
      serialInvalid: 'Serial number is not valid',
      serialInvalidCharacters:
        'Serial number must not contain special characters',
      serialRequired: 'Serial number is required',
      softwareVersion: 'System details',
      structureInvalid: 'Structure version is not valid',
      structureInvalidCharacters:
        'Structure version must not contain special characters',
      structureRequired: 'Structure version is required',
      structure_version: 'Version of the structure',
      statusResponsible: 'Responsible for the change',
      statusInfo: {
        created: {
          name: '0 - Created',
          definition: 'Serial number planned in production.',
          responsible: 'Production manager or substitute',
        },
        producing: {
          name: '1.0 - In production',
          definition: 'Device on the production line.',
          responsible: 'Production manager or substitute',
        },
        validation: {
          name: '1.1 - In validation',
          definition: 'Device pending validation by quality.',
          responsible: 'Production manager or quality',
        },
        packaging: {
          name: '1.2 - In packaging',
          definition: 'Device being packed for storage.',
          responsible: 'Warehouse staff or production manager',
        },
        enabled: {
          name: '2 - Enabled',
          definition: 'Device validated, stored and ready for sale.',
          responsible: 'Warehouse staff or production manager',
        },
        pending_shipment: {
          name: '3.0 - Pending Shipment',
          definition: 'Device assigned or reserved for sale to a customer. Device pending shipment after maintenance.',
          responsible: 'Warehouse staff or production manager',
        },
        picked_up: {
          name: '3.1 - Picked up',
          definition: 'Device collected from our facilities by a distributor.',
          responsible: 'Warehouse staff or production manager',
        },
        rented: {
          name: '4.0 - Rented',
        },
        purchased: {
          name: '4.1 - Purchased',
        },
        substitution: {
          name: '4.2 - Substitution',
        },
        maintenance: {
          name: '5 - In maintenance',
        },
        disabled: {
          name: '6 - Disabled',
        },
      },
      table: {
        actions: 'Actions',
        active: 'Active',
        device_state: 'State',
        id: 'Device code',
        model: 'Model',
        o_id: 'Organization ID',
        organization: 'Organization',
        serial: 'Serial Nº',
        type: 'Type',
        org_distributor: 'Distributor',
        org_customer: 'Customer',
        more_than_one: 'Multiple clients'
      },
      stateSuggestion: {
        title: 'State change',
        currentState: 'This device is in state',
        question: 'Do you want to change its state?',
        doNothing: 'Do nothing',
        save: 'Save change',
      },
      title: 'Devices list',
      total_device_steps: 'Total device steps',
      total_device_time: 'Total device time',
      type_device: 'Type of device',
      type_device_required: 'Type of device is required',
    },
    dashboards: {
      addDataSourceOrMetric: 'Add to dashboard',
      createDataSource: 'Create data source',
      createMetric: 'Create metric',
      name_required: 'Dashboard name is required',
      title: 'Data Analytics',
      add: 'New dashboard',
      edit: 'Edit dashboard',
      cancelEdit: 'Cancel changes',
      saveChanges: 'Save changes',
      addVisualization: 'Visualization',
      dataSources: 'Data Sources',
      back: 'Back',
      skip: 'Skip',
      next: 'Next',
      delete: {
        confirm_header: 'Delete Dashboard',
        confirm_message: 'Are you sure you want to delete "{{name}}"?',
        confirm_accept: 'Delete',
        confirm_reject: 'Cancel',
        success_summary: 'Deleted',
        success_detail: '"{{name}}" was successfully deleted.',
        error_summary: 'Error',
        error_detail: 'Failed to delete the dashboard. Please try again.',
      },
      visualization: {
        create: 'Create visualization',
        type: 'Visualization type',
        tableType: 'Table',
        lineChartType: 'Line Chart',
        areaChartType: 'Area Chart',
        barChartType: 'Bar Chart',
        cardType: 'Metric Card',
        selectDataSource: 'Select Data Source',
        parameters: 'Visualization parameters',
        multidimensional: 'Multidimensional',
        unidimensional: 'Unidimensional',
      },
      datasource: {
        base: 'Base',
        custom: 'Custom',
        metrics: 'Metrics',
        tables: 'FROM',
        group_by: 'GROUP BY',
        filters: 'WHERE',
        order_by: 'ORDER BY',
        group_by_filters: 'GROUP BY - HAVING',
        group_by_aggregations: 'GROUP BY - MÉTRICAS AGREGADAS',
        column_selection: 'SELECT',
        name: 'DataSource Name Selection',
        createDataSource: 'Create',
        create: 'Create DataSource',
        select_tables: 'Select Tables:',
        select_columns: 'Select columns:',
        select_date_trunc_unit: 'Select Time Trunc Unit:',
        select_name: 'Select Name:',
        column: 'Column',
        function: 'Function',
        order_by_direction: 'Direction',
        select_filters: 'Select filters:',
        select_logical_operator: 'Select the logic operator:',
        add_filter: 'Add filter',
        edit_filter: 'Edit filter',
        operator: 'Operator',
        value: 'Value',
        add_aggregation: 'Add aggregation',
      },
      metric: {
        name: 'Name of the metric',
        selectDataSource: 'Select Data Source',
        selectAggregation: 'Select Aggregation',
        aggregateFunction: 'Select Aggregation Function',
        aggregateColumn: 'Select Column to aggregate',
      },
      name_invalid: 'Invalid dashboard name',
      name_invalid_characters:
        'Dahsboard name must not contain special characters',
      description_invalid_characters:
        'Dashboard description must not contain special characters',
      name: 'Dashboard name',
      description: 'Dashboard description',
      table: {
        name: 'Name',
        description: 'Description',
        version: 'Version',
        created_at: 'Creation date',
        updated_at: 'Last update',
        actions: 'Delete',
      },
      valueInput: {
        noValueRequired: 'No value required',
        chipsHint: 'Type a value and press Enter to add it',
        from: 'From',
        to: 'To',
        rangeHint:
          'Enter the lower and upper bounds. Leave a field empty for an open-ended range',
      },
    },
    surveys: {
      title: 'Surveys',
      add: 'Create survey',
      name: 'Survey name',
      name_required: 'Survey name is required',
      description: 'Survey description',
      study: 'Study',
      priority: 'Priority',
      priority_values: {
        mandatory: 'Mandatory',
        optional: 'Optional',
      },
      send_frequency_days: 'Send frequency (days)',
      response_time_limit_days: 'Response time limit (days)',
      starts_at: 'Start date',
      start_date_required: 'Start date is required',
      anonymization_type: 'Anonymization type',
      anonymization_type_values: {
        none: 'None',
        all_answers: 'All Answers',
        optional: 'Optional',
      },
      anonymization_optional_helper: '(user chooses when answering)',
      send_strategy: 'Send strategy',
      send_strategy_values: {
        all_users: 'All Users',
        admin_only: 'Admin Only',
      },
      recipients: 'Recipients',
      user_name: 'User name',
      org_name: 'Organization name',
      state: 'State',
      days_left: 'Days left',
      recipient_states: {
        pending: 'Pending',
        answered: 'Answered',
        overdue: 'Overdue',
      },
      organization_ids: 'Recipient organizations',
      select_role: 'Select role',
      select_organizations: 'Select organizations',
      selected_organizations: 'Selected',
      search_organizations: 'Search organizations',
      select_strategy: 'Select strategy',
      depends_on_field: 'Does this question depend on another?',
      select_field: 'Select question',
      depends_on_value: 'Which value does it depend on?',
      select_value: 'Select value',
      configuration: 'Configuration',
      survey_questions: 'Questions',
      survey_fields: 'Survey fields',
      question_title: 'Question title',
      field_name: 'Field name',
      question_type: 'Question type',
      question_description: 'Question description',
      field_title: 'Field title',
      field_type: 'Field type',
      added_options: 'Added options',
      field_types: {
        text: 'Text',
        number: 'Number',
        boolean: 'Si/No',
        select: 'Options',
        multiselect: 'Multiple Options',
      },
      question_options: 'Question options',
      add_question: 'Add question',
      add_questions: 'Add questions',
      questions_added: '{{count}} questions added',
      add_question_option: 'Add option',
      added_question_options: 'Added options',
      one_time_send: 'One-time send',
      no_limit: 'No limit',
      field_dependency: 'Depends on',
      select: 'Select',
      required: 'Required',
      template_required: 'At least one question is required in the survey',
      name_survey_required: 'Survey name is required',
      starts_at_required: 'Start date is required',
      question_name_duplicate: 'A question with this name already exists',
      warning: 'Warning',
      cannot_delete_field_has_dependencies:
        'Cannot delete this question because another question depends on it.',
      delete: {
        confirm_header: 'Delete Survey',
        confirm_message: 'Are you sure you want to delete "{{name}}"?',
        confirm_accept: 'Delete',
        confirm_reject: 'Cancel',
        success_summary: 'Deleted',
        success_detail: '"{{name}}" was successfully deleted.',
        error_summary: 'Error',
        error_detail: 'Failed to delete the survey. Please try again.',
      },
      table: {
        name: 'Name',
        description: 'Description',
        version: 'Version',
        created_at: 'Creation date',
        updated_at: 'Last update',
        created_by: 'Created by',
        active: 'Status',
        filters: {
          created_by: 'Search by user...',
        },
        details: 'Details',
      },
      borrar: 'Delete',
      pausar: 'Pause',
      reanudar: 'Resume',
      add_recipients: 'Add recipients',
      delete_recipients: 'Delete recipients',
      descargarrespuestasencvs: 'Download responses',
      paused: 'Paused',
      information: 'Information',
      save: 'Save',
      confirm_save_message:
        "Do you want to create this survey? It can't be modified once created",
      select_all: 'Select all',
      deselect_all: 'Deselect all',
      drafts_title: 'Drafts',
      untitled_draft: 'Untitled draft',
      created_by: 'Created by',
      last_edited: 'Last edited',
      no_drafts: 'No drafts',
      saveDraft: 'Save draft',
      edit_draft: 'Edit draft',
      delete_draft: 'Delete draft',
      confirm_delete_draft_header: 'Delete draft',
      confirm_delete_draft_message:
        'Are you sure you want to delete this draft? This cannot be undone.',
      exitConfirmHeader: 'Unsaved changes',
      exitConfirmMessage: 'You have unsaved changes',
      exitWithoutSaving: 'Exit without saving',
      section_general: 'General information',
      section_configuration: 'Survey type & anonymization',
      section_scheduling: 'Scheduling',
      section_recipients: 'Recipients',
      responses: 'Number of responses',
      overdue_users: 'Overdue users',
      saveDraftConfirmHeader: 'Save draft',
      saveDraftConfirmMessage:
        'The recipient organizations will not be saved in the draft. Are you sure you want to save the draft?',
    },
    incidents: {
      titleMenu: 'Incidences and MOs',
      codeIncidence: 'Incident code',
      titleSingle: 'Incident',
      detected: 'Detected by',
      detection: 'Detection',
      comunication_channel: 'Communication channel',
      confirmClose: 'Incident closure confirmation',
      confirmCloseMessage:
        'Are you sure you want to close the incident? This action cannot be undone.',
      dateClosedIncidence: 'Closure date',
      autoCloseInfo:
        'Upon acceptance, the incident will be marked as closed. The closure date and time will be recorded automatically. This action will not generate an associated maintenance order.',
      doubleConfirmClose:
        'Do you confirm that you want to close this incident?',
      noOpcionIncidences:
        'No priority/type/severity options are currently available.',
      statusScope: {
        open: 'Open',
        closed: 'Closed',
        placeholder: 'Select a status',
      },
      alarms: {
        title: 'Alarms',
      },
      buttonAssing: 'Assign Incident to OM',
      buttonCreateOM: 'Create OM in incident',
      buttonCloseOM: 'Close OM',
      buttonCloseIncidence: 'Close Incident ',
      lastMonth: 'Last month default',
      sn_product: 'Serial number',
      notDetails: 'No details are available for this incident.',
      assignOrder: 'Assign maintenance order',
      serial_number: 'Serial number',
      detected_by: 'Detected by',
      created_at: 'Creation date',
      date_closed: 'Closing date',
      assigned: 'Assigned to',
      create: 'Create incident',
      createIncident: 'Create incident',
      createOrder: 'Create maintenance order',
      impact: 'Severity',
      containment_actions: 'Containment actions',
      create_description:
        'Complete the incident details. You can create a maintenance order or associate an existing one. Click save when you are finished.',
      d_id: 'Device serial number',
      date: 'Registration date and time',
      description: 'Description',
      description_title: 'Description',
      details: 'Incident details',
      notAvailable: 'Not available',
      device_name: 'Device',
      edit: 'Edit incident',
      estado_incidencia: {
        abierta: 'Pending',
        cancelada: 'Cancelled',
        cerrada: 'Closed',
        en_espera: 'On Hold',
        en_proceso: 'In Progress',
        reabierto: 'Reopened',
        resuelta: 'Resolved',
        verificada: 'Verified',
      },
      omAssigned: 'Assigned maintenance orders',
      notAssigned: 'This incident has no assigned maintenance orders.',
      titleOrder: 'Maintenance order',
      origin: 'Origin',
      priority: 'Priority',
      priority_type: {
        alta: 'High',
        baja: 'Low',
        critica: 'Critical',
        media: 'Medium',
      },
      search_device_name: 'Search by device name',
      search_priority: 'Search by priority',
      search_status: 'Search by status',
      search_title: 'Search by incident title',
      start_time: 'Date detection',
      status: 'Status',
      title: 'Incidents',
      type: 'Type',
      createMaintenanceOrder: {
        maintenance_type_label: 'Maintenance Type',
        order_status_label: 'Maintenance Order Status',
        responsible_label: 'Responsible',
        button_add_om: 'Add MO',
        maintenance_type_placeholder: 'Select maintenance type',
        order_status_placeholder: 'Select order status',
        description_placeholder: 'Description of the maintenance order',
      },
      assignIncidentToOm: {
        title: 'Assign Incidents to Maintenance Order',
        incident_label: 'Incident',
        search_incident_placeholder: 'Search for an incident...',
        no_device: 'The maintenance order has no associated serial number',
        none_available: 'There are no incidents available for this device',
        same_device_hint: 'Only open incidents for the same device are shown.',
      },
      closeComment: 'Comment',
      open: 'Open',
      closed: 'Closed',
      response_time: 'Response time',
      confirmCloseButton: 'Close incident',
      closeCommentRequired: 'The closing comment is required',
      assignOrder_noDevice: 'The incident has no associated serial number',
      assignOrder_noneAvailable:
        'There are no maintenance orders available for this device',
      assignOrder_sameDeviceHint:
        'Only open maintenance orders for the same device are shown.',
    },
    maintenance_orders: {
      detailsOm: 'Maintenance order details of',
      details: 'Details',
      can_not_load: 'Could not be loaded',
      associated_incidences: 'Associated incidents',
      no_incidences: 'No associated incidents',
      allocated_times: 'Allocated times',
      allocate_time: 'Allocate time',
      no_allocated_times: 'No allocated times',
      code: 'Code',
      description: 'Description',
      status: 'Status',
      type: 'Type',
      creation_date: 'Creation date',
      execution_date: 'Execution date',
      close_date: 'Closing date',
      component_serial_number: 'Component serial number',
      component_description: 'Component description',
      observations: 'Observations',
      allocate_time_error: 'Could not allocate time',
      initial_date: 'Start date',
      final_date: 'End date',
      comments: 'Comments',
      duration: 'Duration',
      final_before_initial: 'The end date must be later than the start date',
      assigned_materials: 'Assigned materials',
      articles_to_assign: 'Articles to assign',
      select_series: 'Select series',
      remove_material: 'Remove material',
      no_assigned_materials: 'No materials assigned yet',
      no_articles_available: 'No articles available',
      confirm_remove_material_title: 'Confirm removal',
      confirm_remove_material_message:
        'Are you sure you want to remove this material?',
      material_removed_success: 'Material removed successfully',
      error_removing_material: 'Error removing material',
      article: 'Article',
      id: 'ID',
      cost: 'Cost',
      series: 'Series',
      quantity: 'Quantity',
      unit_cost: 'Unit cost',
      total_cost: 'Total cost',
      date: 'Date',
      assign_material: 'Assign material',
      available_quantity: 'Available quantity',
      no_data: 'No data available',
      closeDialog: {
        title: 'Do you want to close this maintenance order?',
        description:
          'When closing the MO, Marsinet will record the closing date and time, the user performing the closure, the associated resolved incidents, and any material and time allocations, if they exist.',
        orderLabel: 'Maintenance order',
        statusActual: 'Current status',
        closingDateTime: 'Closing date and time',
        confirmDescription:
          'The final date and time will be recorded at the exact moment the closure is confirmed.',
        associatedIncidents:
          'Associated incidents that will be marked as resolved',
        notAssociatedIncidences:
          'There are no incidents associated with this MO',
        associatedImputations: 'Associated allocations',
        materialImputations: 'Allocated materials:',
        timeImputations: 'Allocated times:',
        closeActionDescription:
          'This action will close the maintenance order and update its status.',
        closeTitle: 'Close maintenance order',
        subtitle: 'Order details',
        closingComment: 'Closing comment',
        closingCommentPlaceholder:
          'Describe how the selected incidents were resolved',
        closingCommentHelp:
          'It will be saved as the closing comment on each resolved incident.',
        commentRequiredError: 'The closing comment is required',
        confirmSingleResolved:
          'Select the incidents that are resolved by this closure',
        loadingIncidents: 'Loading associated incidents...',
        mustCloseIncidentHint:
          'Mark at least one incident as resolved and add a closing comment',
        noIncidentsToCloseError:
          'This order has no associated incidents that can be closed',
        singleIncidentRequiredError:
          'You must mark the associated incident as resolved to close the order',
        noIncidentSelectedError:
          'You must mark at least one incident as resolved',
        closed: 'Maintenance order closed successfully',
        close_error: 'Could not close the maintenance order',
        incidences_close_error:
          'The order was closed, but {{count}} incidents could not be closed',
      },
      responsible: 'Responsible',
      labelDescription: 'Type item to search',
      evidences: 'Evidence',
      employee: 'Employee',
      assigned_user: 'Assigned user',
      allocation_date: 'Allocation date',
      material: 'Material',
      select_material: 'Select a material',
      available: 'available',
      no_available_materials: 'No materials available',
      material_assigned_success: 'Material assigned successfully',
      assign_material_error: 'Could not assign the material',
      site: 'Site',
      select_site: 'Select a site',
      warehouse: 'Warehouse',
      select_warehouse: 'Select a warehouse',
      warehouse_location: 'Location',
      select_warehouse_location: 'Select a location',
      can_not_load_incidences: 'Could not load the associated incidents',
      can_not_load_allocated_times: 'Could not load the allocated times',
      can_not_load_available_materials:
        'Could not load the available materials',
      pdf_download_error: 'Could not download the PDF',
      changeStatus: {
        title: 'Change the order status',
        button: 'Change status',
        current: 'Current status',
        new: 'New status',
        help: 'Final statuses are not available: the order is completed through the closing flow.',
        updated: 'Status updated successfully',
        error: 'Could not update the status',
      },
    },
    ingestions: {
      model: 'Model',
      role: 'Role',
      selectRole: 'Search by role',
      action: 'Action',
      date: 'Date',
      download: 'Download',
      downloadFiles: 'Download files',
      graphs: 'Graphs',
      id: 'ID',
      is_session: 'Is session',
      is_session_false: 'No',
      is_session_true: 'Yes',
      is_test: 'Is test',
      name: 'Zip file name',
      notProcessed: 'Not processed',
      process: 'Process',
      processed: 'Processed',
      see_details: 'See details',
      detailsTitle: 'Error details',
      ingestion_error_code: 'Error description',
      ingestion_error: 'Error details',
      name_zip: 'ZIP file name',
      search: 'Search by file name or serial number of the device',
      search_battery_cycles: 'Search by battery cycles',
      search_d_name: 'Search by device name',
      search_name: 'Search by file name',
      selectState: 'Select state',
      title: 'Data ingestions',
      versions: 'Versions',
      dateFormatHint: 'Example date to search 01022026',
      placeHolderDate: '01022026',
      with_errors: 'With errors',
      without_errors: 'Witout errors',
    },
    pendingSurveys: {
      title: 'Pending surveys',
      loading: 'Loading...',
      noPendingSurveys: 'No pending surveys',
      priority: {
        mandatory: 'Mandatory',
        optional: 'Optional',
      },
      requestLoading: 'Loading survey...',
      daysLeftUnit: 'days',
      selectRequest: 'Select',
      yes: 'Yes',
      no: 'No',
      anonymizeYourAnswers: 'Do you want to anonymize the survey?',
      anonymizeAllYourAnswers: 'This survey is anonymized',
      close: 'Exit without saving',
      table: {
        name: 'Survey name',
        daysLeft: 'Days left',
        dueDate: 'Due date',
        description: 'Description',
        priority: 'Priority',
        status: 'Status',
      },
      send: 'Send',
      noSurveyLoaded: 'No survey loaded',
      anonimizationYes: 'This answer will be completely anonymized.',
      confirmSubmitMessage: "You won't be able to edit your answers after",
      confirmSubmitHeader: 'Are you sure you want to submit this survey?',
      saveDraft: 'Save draft',
      draftOngoing: 'Draft in progress',
      exitConfirmHeader: 'Unsaved changes',
      exitConfirmMessage:
        'You have unsaved changes. Do you want to save them as a draft before leaving?',
      exitWithoutSaving: 'Exit without saving',
      saveDraftAndExit: 'Save draft and exit',
      tabs: {
        pending: 'Pending Surveys',
        previous: 'Previous Answers',
      },
      previous: {
        empty: "You haven't answered any surveys yet",
        survey: 'Survey',
        answerNumber: 'Answer No.',
        anonymized: 'Anonymized',
        date: 'Date',
        detailTitle: 'Answer Detail',
      },
    },
    errors: {

      ZIP_MISSING_JSON_OR_CSV: 'ZIP file does not contain a JSON or CSV file',
      DEVICE_NOT_FOUND: 'Device not found',
      CSV_NO_ROWS: 'CSV file is empty',
      PATIENT_NOT_FOUND: 'Patient not found',
      JSON_MALFORMED: 'The JSON is malformed',
      ZIP_INVALID_FORMAT: 'Invalid ZIP format',
      INVALID_SIGNATURE: 'Invalid signature',
      DIRECTORY_NOT_FOUND: 'Directory not found',
      notErrors: 'No specific details are available for this error',
      BLOB_NOT_FOUND_OR_ACCESS_DENIED: 'The file could not be accessed in storage',
      MISSING_DEVICE_AND_PATIENT_ID: 'The file does not contain a device ID or patient ID',
      DEVICE_ID_NOT_FOUND: 'The file does not contain the device ID',
      PATIENT_ID_NOT_FOUND: 'The file does not contain the patient ID',
      INVALID_SESSION_DATA: 'Invalid session data in the CSV file',
      ZIP_INVALID_STRUCTURE: 'Invalid ZIP file structure',
      CSV_TOO_LARGE: 'The CSV file exceeds the maximum allowed size',
      CSV_PROCESSING_ERROR: 'Error processing the CSV file',
      ALARMS_PROCESSING_ERROR: 'Error processing alarms',
      UNKNOWN_ERROR: 'Unexpected error occurred while processing the file',

    },
    institutions: {
      add: 'New organization',
      control_panel: 'Control panel',
      bubble: {
        detailsOf: 'Details of',
        detailsOfOrganization: 'Details of the organization',
        devicesNumberProducing: 'Producing devices',
        deviceNumberStock: 'Devices in stock',
        deviceNumberRentedOrPurchased: 'Rented or purchased devices',
        deviceNumberInMaintenance: 'Devices in maintenance',
        deviceNumberDisabled: 'Disabled devices',
        familiesNumber: 'Number of families',
        noData: 'No data to display',
        other: 'Other devices',
      },
      form: {
        address: 'Address',
        addressRequired: 'Address is required',
        city: 'City',
        cityRequired: 'City is required',
        contact: 'Contact details',
        contactname: 'Name',
        country: 'Country',
        countryRequired: 'Country is required',
        devicesNotFound: 'No devices found for this organization',
        email: 'Email ',
        name: 'Name organization',
        nameRequired: 'Name is required',
        number: 'Number',
        numberRequired: 'Number is required',
        postalCode: 'Postal code',
        postalCodeRequired: 'Postal code is required',
        premium: 'Premium',
        telephone: 'Telephone',
        warningDeleteDeviceTitle: 'Action not recommended',
        warningDeleteDeviceMessage:
          'This is the last device linked to the organization. If you remove it without assigning another one first, the organization will no longer be visible to you until a new device is assigned by the administration.',
        creator: 'Creator',
        changeCreator: 'Change creator',
        creatorNotFound: 'No creator'
      },
      messages: {
        blocked:
          'The data of this organization cannot be accessed because it is blocked.',
        delete: 'Organization deleted',
        deleteConfirm:
          'Would you like to delete the organization and the relation with its devices?',
        deleteConfirmTitle: 'Delete confirmation',
        deleteError: 'Error deleting organization',
        deleteSuccess: 'Organization deleted successfully',
      },
      table: {
        actions: 'Actions',
        id: 'ID',
        name: 'Name organization',
        premium: 'Premium',
        role: 'Role',
        created_by: 'Creator',
      },
      title: 'Organization List',
    },
    login: {
      email: 'Email',
      forgotPassword: 'Forgot your password?',
      invalidCharacters: 'Invalid characters in the email',
      invalidCredentials: 'Invalid username and password',
      invalidEmail: 'Invalid email',
      login: 'Login',
      or: 'Or',
      password: 'Password',
      register: 'Register',
      requiredEmail: 'Email is required',
      requiredPassword: 'Password is required',
      slogan: {
        a: 'Connecting data,',
        b: 'transforming lives',
      },
    },
    maintenance: {
      alarms: {
        title: 'Alarms',
      },
      ingestion: {
        abdl: 'Abduction L',
        abdr: 'Abduction R',
        anckle_lock: 'Ankle lock',
        assistedTorque: 'Assistive Torque',
        batery: 'Batery',
        battery_cycles: 'Battery cycles',
        chest: 'Chest size',
        config: 'Configuration',
        corseLC: 'L short',
        corseLE: 'L envolved',
        corseSC: 'S short',
        corseSE: 'S envolved',
        corset: 'Corset',
        current: 'Current',
        d_name: 'Serial number',
        dorsal_flex_max: 'Dorsal flexion max',
        elev_control: 'Elevation control',
        elev_ctrl: 'Elevation control',
        elev_motor: 'Elevation motor',
        elev_sens: 'Elevation sensor',
        energy_monitor: 'Energy monitor',
        env_temp: 'Environment temperature',
        exo: 'Exoskeleton',
        femurl: 'Femur L',
        femurr: 'Femur R',
        file: 'File',
        flexanklel: 'Flexos ankle L',
        flexankler: 'Flexos ankle R',
        flexkneel: 'Flexos knee L',
        flexkneer: 'Flexos knee R',
        flexoshipl: 'Flexos hip L',
        flexoshipr: 'Flexos hip R',
        generalInformation: 'General',
        generalState: 'General state',
        global_position: 'Global position',
        graphs: {
          aan1LevelAssistanceLh: 'AAN1 Left Hip',
          aan1LevelAssistanceLk: 'AAN1 Left Knee',
          aan1LevelAssistanceRh: 'AAN1 Right Hip',
          aan1LevelAssistanceRk: 'AAN1 Right Knee',
          aan2LevelAssistanceLh: 'AAN2 Left Hip',
          aan2LevelAssistanceLk: 'AAN2 Left Knee',
          aan2LevelAssistanceRh: 'AAN2 Right Hip',
          aan2LevelAssistanceRk: 'AAN2 Right Knee',
          assistedTorqueLeftHip: 'Left hip torque',
          assistedTorqueRightHip: 'Right hip torque',
          assistedTorqueLeftKnee: 'Left knee torque',
          assistedTorqueRightKnee: 'Right knee torque',
          capacity: 'Percentage',
          current1: 'L-ABD',
          current2: 'LH',
          current3: 'LK',
          current4: 'LA',
          current5: 'R-ABD',
          current6: 'RH',
          current7: 'RK',
          current8: 'RA',
          elevCtrl: 'Elevation control',
          elevSens: 'Distance',
          energyMonitorExo: 'Exoskeleton',
          energyMonitorWf: 'Walker',
          environmentTemperature: 'Temperature',
          globalPosition: 'Global position',
          imuPitchAngle: 'Sagittal plane inclination angle',
          imuRollAngle: 'Frontal plane inclination angle',
          intentionEffortHipLeft: 'Left hip activation effort',
          intentionEffortHipRight: 'Right hip activation effort',
          intentionEffortKneeLeft: 'Left knee activation effort',
          intentionEffortKneeRight: 'Right knee activation effort',
          load_cell: 'Load Cell',
          lowerLimit: 'Lower limit',
          maxLegend: 'You have reached the maximum variables selected',
          motorTemperature1: 'L-ABD',
          motorTemperature2: 'LH',
          motorTemperature3: 'LK',
          motorTemperature4: 'LA',
          motorTemperature5: 'R-ABD',
          motorTemperature6: 'RH',
          motorTemperature7: 'RK',
          motorTemperature8: 'RA',
          motorTorque1: 'L-ABD',
          motorTorque2: 'LH',
          motorTorque3: 'LK',
          motorTorque4: 'LA',
          motorTorque5: 'R-ABD',
          motorTorque6: 'RH',
          motorTorque7: 'RK',
          motorTorque8: 'RA',
          motorsAngRef1: 'L-ABD reference',
          motorsAngRef2: 'LH reference',
          motorsAngRef3: 'LK reference',
          motorsAngRef4: 'LA reference',
          motorsAngRef5: 'R-ABD reference',
          motorsAngRef6: 'RH reference',
          motorsAngRef7: 'RK reference',
          motorsAngRef8: 'RA reference',
          motorsEn: 'Motors enabled',
          motorsInt1: 'L-ABD',
          motorsInt2: 'LH',
          motorsInt3: 'LK',
          motorsInt4: 'LA',
          motorsInt5: 'R-ABD',
          motorsInt6: 'RH',
          motorsInt7: 'RK',
          motorsInt8: 'RA',
          motorsMotor1Mille: 'L-ABD Mille',
          motorsMotor1Orbis: 'L-ABD Angle',
          motorsMotor2Mille: 'LH Mille',
          motorsMotor2Orbis: 'LH Angle',
          motorsMotor3Mille: 'LK Mille',
          motorsMotor3Orbis: 'LK Angle',
          motorsMotor4Mille: 'LA Mille',
          motorsMotor4Orbis: 'LA Angle',
          motorsMotor5Mille: 'R-ABD Mille',
          motorsMotor5Orbis: 'R-ABD Angle',
          motorsMotor6Mille: 'RH Mille',
          motorsMotor6Orbis: 'RH Angle',
          motorsMotor7Mille: 'RK Mille',
          motorsMotor7Orbis: 'RK Angle',
          motorsMotor8Mille: 'RA Mille',
          motorsMotor8Orbis: 'RA Angle',
          outrange: 'The selection is out of range',
          position: 'Position',
          realTorqueLeftHip: 'Actual — Left hip',
          realTorqueRightHip: 'Actual — Right hip',
          realTorqueLeftKnee: 'Actual — Left knee',
          realTorqueRightKnee: 'Actual — Right knee',
          refTorqueLeftHip: 'Reference — Left hip',
          refTorqueRightHip: 'Reference — Right hip',
          refTorqueLeftKnee: 'Reference — Left knee',
          refTorqueRightKnee: 'Reference — Right knee',
          sit_angle: 'Angle',
          state: 'Device status',
          sys_status: 'Safety status',
          temperature: 'Degrees celsius',
          thresholdHipFlexLeft: 'Left hip threshold',
          thresholdHipFlexRight: 'Right hip threshold',
          thresholdKneeFlexLeft: 'Left knee threshold',
          thresholdKneeFlexRight: 'Right knee threshold',
          timeWalking: 'Walking time',
          upperLimit: 'Upper limit',
          voltage: 'Volts',
          motorEpos1: 'Epos1 LH',
          motorEpos2: 'Epos2 RH',
          motorEpos3: 'Epos3 LK',
          motorEpos4: 'Epos4 RK',
        },
        heightmarcoatlas: 'Height marco',
        hip: 'Hip width',
        imuData: 'Inclination angles',
        loadCell: 'Load cell',
        motorSens2: 'Sensor orbis of the motors',
        motorsCurrent: 'Current of the motors',
        motorsInformation: 'Motors',
        motorsInt: 'Motors Intention',
        motorsRef: 'Angle',
        motorsSens1: 'Sensor mille of the motors',
        motorsTemp: 'Temperature of the motors',
        motorsTorque: 'Torque of the motors',
        p_name: 'Patient name',
        percentage: 'Percentage',
        plantar_flex_max: 'Max plantar flexion',
        refAndRealTorque: 'Joint Torque',
        shoe: 'Shoe size',
        sit_angle: 'Sit angle',
        state: 'State of the device',
        sys_status: 'Security status',
        tempEpos: 'Temperature Epos',
        temperature: 'Temperature',
        tibial: 'Tibia L',
        tibiar: 'Tibia R',
        title: 'Session ingestion',
        voltage: 'Voltage',
        walker: 'Walker',
        walker_info: 'Walker',
      },
      test: {
        detail: 'Test details',
        fail: 'Fail',
        ok: 'Completed',
        title: 'Tests ingestion',
      },
      ota: {
        title: 'OTA Firmware Upload',
        upload_description:
          'Upload new firmware versions for device components (CM7, CM4 or ESP). The system will validate the metadata embedded in the binary to ensure integrity.',
        software_type: 'Software Type',
        select_software_type: 'Select a software type',
        software_types: {
          cm7_description: 'Main processor - Device brain',
          cm4_description: 'Communications processor - Connectivity',
          esp_description: 'WiFi processor - Wireless connectivity',
        },
        version_required: 'Firmware Version*',
        version_placeholder: 'E.g: 1.2.3',
        version_info: 'Enter the version in semantic format (X.Y.Z)',
        firmware_file: 'Firmware File*',
        choose_file: 'Select file',
        selected_file: 'Selected file',
        upload: 'Upload',
        uploading: 'Uploading...',
        version: 'Version',
        version_format_invalid:
          'The version format is invalid. Use the X.Y.Z format',
        select_file_and_type: 'Please select a file and a software type',
        invalid_software_type: 'Invalid software type',
        version_conflict:
          'The version already exists or is lower than the last published',
        checksum_mismatch:
          'File integrity check failed. The file may have been corrupted during upload.',
        firmware_metadata: 'Firmware Metadata',
        project: 'Project',
        binary_version: 'Binary Version',
        board_version: 'Board Version',
        microcontroller_id: 'Microcontroller ID',
        creation_datetime: 'Creation Date/Time',
        file_metadata_version: 'File metadata version',
        git_tag: 'Git Tag',
        chip_id: 'Chip ID',
        compilation_time: 'Compilation Time',
        compilation_date: 'Compilation Date',
        upload_authorization: 'Upload Authorization Token',
        upload_authorization_info:
          'Paste the authorization token received via email (optional)',
        token_valid: '✓ Authorization token is valid',
        token_invalid_format: '❌ Authorization token format is invalid',
        dont_have_token: "Don't have an authorization token?",
        request_token_button: 'Request Upload Token',
        token_request_sent:
          'Token sent successfully. Check your email inbox to get it.',
        token_already_used:
          'Authorization failed: The authorization token has already been used',
        error_reading_file_metadata: 'Error reading file metadata',
        error_requesting_token: 'Error requesting token',
        invalid_metadata: 'Cannot upload file with invalid metadata: ',
        version_mismatch_metadata: 'Version mismatch with file metadata',
        token_required: 'Upload authorization token is required',
        token_format_invalid: 'Upload token format is invalid',
      },
      title: 'Maintenance',
    },
    menu: {
      alarms: 'Alarms',
      changepassword: 'Change Password',
      devices: 'Devices',
      incidentsOMtitle: 'Incidents and Maintenance Orders',
      titleIncidents: 'Incidents',
      maintenance_orders_tab: 'Maintenance Orders',
      institutions: 'Organizations',
      home: 'Main Panel',
      ingestions: 'Ingestions',
      language: 'Language',
      maintenance: 'Maintenance',
      myAccount: 'My Account',
      patients: 'Patients',
      privacy: 'Privacy',
      report: 'Report',
      session_record: 'Session Records',
      sessions: 'Device Usage',
      signOut: 'Sign Out',
      users: 'Users',
      dashboards: 'Analytics',
      ID_incident: 'Incident ID',
      ota: 'OTA Firmware Upload',
      pendingSurveys: 'Pending surveys',
      surveyCreation: 'Survey creation',
    },
    notVerified: {
      error: 'Email not registered, please try to register again',
      success: 'The account has been activated',
    },
    patients: {
      add: 'New patient',
      form: {
        abd: 'Abduction',
        abdl: 'Abduction left',
        abdr: 'Abduction right',
        add: 'Add',
        addAffectation: 'Type the new affectation',
        address: 'Address',
        affectation: 'Impairment Level',
        ankle_lock: 'Ankle lock',
        ankle_stance: 'Ankle stance',
        birthDate: 'Birth date',
        chest_size: 'Chest size',
        city: 'City',
        corset: 'Corset',
        country: 'Country',
        cp: 'Postal code',
        email1: 'Legal guardian email 1',
        email2: 'Legal guardian email 2',
        femur_len_l: 'Femur length left',
        femur_len_r: 'Femur length right',
        flex_dorsal_max: 'Max dorsal flexion',
        flex_plantar_max: 'Max plantar flexion',
        flexos_hip: 'Flexos hip',
        flexos_knee: 'Flexos knee',
        height: 'Height',
        height_marco_atlas: 'Height marco atlas',
        hip_width: 'Hip width',
        institution: 'Organization',
        lastName: 'Last name',
        legalGuardian: 'Legal guardian',
        legal_guardian_name_1: 'Legal guardian name 1',
        legal_guardian_name_2: 'Legal guardian name 2',
        measurementSelector: 'Measurement',
        mobilityLevels: {
          level1NoRestrictions: 'Level I - Walks without restrictions',
          level2WithLimitations: 'Level II - Walks with limitations',
          level3WithAssistiveDevice:
            'Level III - Walks using a handheld assistive device',
          level4LimitedSelfMobility:
            'Level IV - Limited self-mobility, may use powered mobility',
          level5WheelchairTransport: 'Level V - Transported in a wheelchair',
        },
        name: 'Name',
        nameLegalGuardian: 'Name of the legal guardian',
        nationality: 'Nationality',
        nif: 'Patient ID',
        number: 'Number',
        pathologies: {
          acquiredBrainInjury: 'Acquired brain injury',
          ame1: 'Spinal muscular atrophy type 1',
          ame2: 'Spinal muscular atrophy type 2',
          ame3: 'Spinal muscular atrophy type 3',
          angelman: 'Angelman syndrome',
          ataxic: 'Ataxic cerebral palsy',
          cerebralPalsy: 'Cerebral palsy',
          cerebralPalsy2: 'Cerebral palsy type 2',
          cerebralPalsy3: 'Cerebral palsy type 3',
          cerebralPalsy4: 'Cerebral palsy type 4',
          cerebralPalsy5: 'Cerebral palsy type 5',
          cervical: 'Cervical spinal cord injury',
          duchenne: 'Duchenne muscular dystrophy',
          dyskinetic: 'Dyskinetic cerebral palsy',
          geneticSynrome: 'Genetic syndrome',
          lumbar: 'Lumbar spinal cord injury',
          medularInjury: 'Spinal cord injury',
          mixed: 'Mixed cerebral palsy',
          muscularDystrophy: 'Muscular dystrophy',
          myasthenia: 'Myasthenia',
          myopathy: 'Myopathy',
          neuromuscularDisease: 'Neuromuscular disease',
          other: 'Rare disease',
          rett: 'Rett syndrome',
          spastic: 'Spastic cerebral palsy',
          thoracic: 'Thoracic spinal cord injury',
          wesSyndrome: 'Wes syndrome',
        },
        pathology: 'Diagnosis',
        phone: 'Phone',
        placeHolderNameLegalGuardian: 'Indicates name of legal guardian',
        postalCode: 'Postal code',
        province: 'Province',
        rom_ankle: 'ROM ankle',
        rom_hip: 'ROM hip',
        rom_knee: 'ROM knee',
        sex: 'Sex',
        sexOptionFemale: 'Female',
        sexOptionMale: 'Male',
        sexOptions: 'Select sex',
        shoe_size: 'Shoe size',
        tibia_len_l: 'Tibia length left',
        tibia_len_r: 'Tibia length right',
        title: 'New patient',
        treatment: 'Treatment',
        treatments: {
          hidrotherapy: 'Hydrotherapy',
          hipotherapy: 'Hippotherapy',
          occupationalTherapy: 'Occupational therapy',
          rehabilitation: 'Rehabilitation',
          strech: ' Stretch',
        },
        walker_len: 'Walker length',
        sit_position: 'Height in seated position',
        stand_position: 'Height in standing position',
        weight: 'Weight',
        yearsOld: 'Years old',
      },
      formValidation: {
        address: 'Address is required',
        birthDate: 'Birth date is required',
        city: 'City is required',
        country: 'Country is required',
        email: 'Email is required',
        emailFormat: 'Email is not valid',
        height: 'Height is required',
        heightMin: 'Height cannot be less than 0',
        invalidCountry: 'Country is not valid',
        invalidDate: 'Date is not valid',
        invalidNationality: 'Nationality is not valid',
        lastName: 'Last name is required',
        name: 'Name is required',
        nationality: 'Nationality is required',
        nif: 'Patient ID is required',
        nifInvalid: 'Patient ID is not valid',
        number: 'Number is required',
        numberInvalid: 'Number is not valid',
        pathology: 'Pathology is required',
        phone: 'Phone is required',
        phoneMaxLength: 'Phone cannot be more than 9 digits',
        phoneMinLength: 'Phone cannot be less than 9 digits',
        phoneNumbers: 'Phone must be a number',
        postalCode: 'Postal code is required',
        postalCodeInvalid: 'Postal code is not valid',
        postalCodeMaxLength: 'Postal code cannot be more than 5 digits',
        postalCodeMinLength: 'Postal code cannot be less than 5 digits',
        province: 'Province is required',
        sex: 'Sex is required',
        treatment: 'Treatment is required',
        weight: 'Weight is required',
        weightMin: 'Weight cannot be less than 0',
      },
      messages: {
        create: 'Patient created',
        createError: 'Error creating patient',
        createSuccess: 'Patient created successfully',
        delete: 'Patient deleted',
        deleteConfirm:
          'Are you sure you want to delete the patient?    If you do, they will be removed from your organization.',
        deleteConfirmTitle: 'Delete confirmation',
        deleteError: 'Error deleting patient',
        deleteSuccess: 'Patient deleted successfully',
        device_not_found: 'Device not found',
        emailAlreadyExists: 'Email already exists',
        organization_not_found: 'Organization not found',
        requestPasswordError: 'User not found',
        somethingUnexpectedHappened: 'Something unexpected happened',
        updateShareConfirm:
          'By checking this box, the application will not share your personal data with clinicians',
        updateShareConfirmTitle:
          'Are you sure you want to stop sharing your personal data?',
        updateNoShareConfirm:
          'By unchecking this box, the application will share your personal data with clinicians',
        updateNoShareConfirmTitle:
          'Are you sure you want to share your personal data?',
      },
      patientData: "Do not share the patient's personal data",
      table: {
        actions: 'Actions',
        filter: 'Search...',
        filters: {
          lastName: 'Last name...',
          lastSession: 'Last session....',
          name: 'Name...',
          p_id: 'Patient ID...',
          sessions: 'Sessions...',
          totalSteps: 'Total steps...',
        },
        institutions: 'Organization',
        lastName: 'Last name',
        lastSession: 'Last session',
        name: 'Name',
        p_id: 'Patient ID',
        sessions: 'Sessions',
        total_steps: 'Total steps',
        device_model: 'Device model',
        all_devices: 'All devices',
        no_devices:
          ' There are no sessions for the selected device model in this range.',
        no_sessions: 'No sessions available for the selected date range.',
        select_model: 'Select a model',
      },
      title: 'Sessions record',
      viewPatient: {
        threshold_force: 'Force threshold',
        anglesTitle: 'Angles',
        address: 'Address',
        clinicalData: 'Clinical data',
        config_patient: 'Patient configuration',
        data: 'General data',
        editPatient: 'Edit data',
        goBack: 'Go back',
        noSessions: 'There are no sessions for this patient',
        sessions: {
          assistanceLevel: 'Patient Contribution',
          assistedTorque: 'Assistive Torque',
          fc: 'Heart rate',
          so2: 'Oxygen saturation',
          so2NoData: 'No oxygen saturation data',
          threshold: 'FC Threshold',
          fc_max: 'Max pulse',
          fc_med: 'Average pulse',
          amount: 'Amount',
          averageStepsSession: 'Average steps / Session',
          averageTimeSession: 'Average time / Session',
          avgStepTimeSeconds: 'Average steps time',
          bpm: 'bpm',
          cadence: 'Cadence',
          cd: 'RH',
          cd_expanded: 'Right hip',
          ci: 'LH',
          ci_expanded: 'Left hip',
          control: 'Control',
          daily: 'Daily',
          direction: 'Direction',
          evolution: 'Evolution',
          fe_hl: 'Left Hip Flexoextension',
          fe_hr: 'Right Hip Flexoextension',
          fe_kl: 'Left Knee Flexoextension',
          fe_kr: 'Right Knee Flexoextension',
          flexValue: 'Joint contracture {{value}}',
          from: 'From',
          gait_cycle: 'Gait cycle(%)',
          gaitKinematicsAnalysis: 'Gait Kinematics Analysis',
          general: 'General',
          generate: 'Generate report',
          hip: 'Hip',
          hipFlexionDistribution: 'Distribution hip joint contracture',
          inSession: 'In session',
          joint_ang: 'Joint angle (º)',
          jointPosition: 'Joint Position',
          knee: 'Knee',
          kneeFlexionDistribution: 'Distribution knee joint contracture',
          leftLeg: 'left leg',
          romHipLeft: 'HI ROM ',
          romKneeLeft: 'KI ROM',
          romAnkleLeft: 'LA ROM',
          romHipRight: 'HD ROM',
          romKneeRight: 'KD ROM',
          romAnkleRight: 'RA ROM',
          leftSideEffortAndThreshold:
            'Effort and activation threshold of the left side',
          mean: 'Mean',
          minutes: 'Minutes',
          mode: 'Mode',
          monthly: 'Monthly',
          newton: 'N*m',
          points: 'Score',
          rd: 'RK',
          rd_expanded: 'Right knee',
          ri: 'LK',
          ri_expanded: 'Left knee',
          rightLeg: 'right leg',
          rightSideEffortAndThreshold:
            'Effort and activation threshold of the right side',
          score: 'Score',
          sd: 'Standard Deviation',
          seconds: 'Seconds',
          sessionDetails: 'Session details',
          steps: 'Steps',
          stepsBackward: 'Steps backwards',
          stepsDistribution: 'Steps distribution',
          stepsForward: 'Steps forward',
          stepsPerMinute: 'Steps per minute',
          thresholdConfiguration: 'Threshold configuration',
          time: 'Time',
          timeDistribution: 'Time distribution',
          title: 'Sessions',
          to: 'To',
          torque: 'Joint activation force (daily maximum)',
          totalSessions: 'Total sessions',
          totalSteps: 'Total steps',
          totalTime: 'Total time of use',
          totalTimeWalking: 'Total time walking',
          vitals: 'Vital signs',
          combined: 'Mode + Direction',
          noDataForGraph: 'No data available for the selected date range.',
        },
      },
    },
    register: {
      successTitle: 'Registration successful',
      acept: 'I have read and accept the terms and conditions ',
      addCodes: 'Add devices',
      address: 'Address',
      ai: 'I consent to the collected metrics being used to improve the service for research and development purposes through artificial intelligence',
      analytics:
        'I consent to the collection of anonymized app usage data to improve the service and provide a faster response to malfunctions or issues',
      birthDate: 'Birthdate',
      birth_dateRequired: 'Birth date is required',
      birthdateRequired: 'Birth date is required',
      change_policy:
        'The other fields are optional, and their information will be used to personalize and enhance your experience. You can change your preferences at any time in the My Account section.',
      charge: 'Charge',
      chargeRequired: 'Charge is required',
      city: 'City',
      cityInvalid: 'Invalid city',
      cityInvalidCharacters: 'Invalid characters in the city',
      cityRequired: 'City is required',
      clinic: 'Professional',
      confidentiality: 'the privacy policy',
      cookiePolicy: 'the cookies policy',
      passwordMax: 'The password cannot be longer than 20 characters',
      cookiePolicyTexts: {
        acceptanceRejectionOrDeletionText1:
          'This website displays information about its Cookie Policy at the bottom or top of the portal at each login so that you are aware and informed of it.',
        acceptanceRejectionOrDeletionText2:
          'You can accept the installation of cookies in your web browser, which you can find on the information panel by means of a button that allows you to accept all cookies by means of a clear, positive, affirmative action.',
        acceptanceRejectionOrDeletionText3:
          'You may also refuse the use of cookies by selecting the "refuse to install and use" option on your browser by clicking on the "block" button. However, you should be aware that if you do so you may not be able to enjoy the full functionality of this website.',
        acceptanceRejectionOrDeletionText4:
          'Ultimately, you have the possibility of deleting previously installed cookies from the configuration of the browser you are using for this purpose.',
        acceptanceRejectionOrDeletionTitle:
          'ACCEPTING, REJECTING OR DELETING COOKIES',
        accordingToOwnershipText1:
          'Own cookies:          these are those that are sent to the user´s terminal equipment from a computer or domain managed by the editor itself and from which the service requested by the user is provided.',
        accordingToOwnershipText2:
          'Third-party cookies:          these are cookies that are sent to the user´s terminal equipment from a computer or domain that is not managed by the editor, but by another entity that processes the data obtained through the cookies.',
        accordingToOwnershipTitle: 'ACCORDING TO OWNERSHIP',
        accordingToTheConservationPeriodText1:
          'Session cookies:          these are a type of cookie designed to collect and store data while the user accesses a web page.',
        accordingToTheConservationPeriodText2:
          'Persistent cookies:          these are a type of cookie in which the data remains stored in the terminal and can be accessed and processed for a period defined by the party responsible for the cookie, which can range from a few minutes to several years.',
        accordingToTheConservationPeriodTitle:
          'ACCORDING TO THE STORAGE PERIOD',
        changingTheCookieSettingsText1:
          'Following the European guidelines of the data protection regulations that may be affected by the use of cookies, you can restrict, block or delete cookies using your browser. Each browser operates differently, the "Help" function will show you how to do this.',
        changingTheCookieSettingsText2:
          'In addition, you can also manage the storage of cookies in your browser using tools such as the following:         ',
        changingTheCookieSettingsTitle: 'CHANGING THE COOKIE SETTINGS',
        cookiePolicyTitle: 'COOKIES POLICY',
        cookiesAffectedByTheRegulationText:
          'According to the EU directive, the cookies that require the user´s informed consent are analytical cookies and advertising and affiliation cookies, with the exception of technical cookies and those necessary for the operation of the website or the provision of services expressly requested by the user.',
        cookiesAffectedByTheRegulationTitle:
          'COOKIES AFFECTED BY THE REGULATION AND EXEMPTED COOKIES',
        dependingOnThePurposeText1:
          'Technical and functional cookies:          these are cookies that allow the user to browse a website, platform or application and to use the different options or services that exist on it.',
        dependingOnThePurposeText2:
          'Analytical cookies:          these are cookies that allow the party responsible for them to monitor and analyse the behaviour of the users of the websites to which they are linked. The information collected through this type of cookies is used to measure the activity of the websites, application or platform and for the elaboration of browsing profiles of the users of these sites, applications and platforms, in order to introduce improvements based on the analysis of the usage data of the users of the service.',
        dependingOnThePurposeText3:
          'Advertising Cookies:          these are those that allow the management, in the most effective way possible, of the advertising spaces that, where appropriate, the editor has included on a website, application or platform from which the requested service is provided based on criteria such as the edited content or the frequency at which the advertisements are shown.',
        dependingOnThePurposeText4:
          'Behavioural advertising cookies:          these collect information on the user´s preferences and personal choices (retargeting) to enable the management, in the most efficient way possible, of the advertising spaces that, where appropriate, the publisher has included on a website, application or platform from which the requested service is provided.',
        dependingOnThePurposeText5:
          'Social Cookies:          these are set by social media platforms on the Services to allow you to share content with your friends and networks. Social media platforms have the ability to track your online activity outside of the Services. This may affect the content and messages you see on other services you visit.',
        dependingOnThePurposeText6:
          'Affiliate cookies:          these enable tracking of visits from other websites with which the website has an affiliation contract (affiliation companies).',
        dependingOnThePurposeText7:
          'Security cookies:          these store encrypted information to prevent the data stored in them from being vulnerable to malicious attacks by third parties.',
        dependingOnThePurposeTitle: 'DEPENDING ON THE PURPOSE',
        informationAboutCookiesText:
          'In accordance with Law 34/2002, of 11 July, on information society services and electronic commerce (LSSI), in relation to Regulation (EU) 2016/679 of the European Parliament and of the Council, of 27 April 2016, General Data Protection Regulation (RGPD) and Organic Law 3/2018, of 5 December, on Data Protection and Guarantee of Digital Rights (LOPDGDD), it is obligatory to obtain the express consent of the user of all websites that use dispensable cookies, before the user browses them.',
        informationAboutCookiesTitle: 'INFORMATION ABOUT COOKIES',
        processingOfPersonalDataText1:
          'MARSI BIONICS S.L is the Data Controller of the personal data of the Data Subject and informs you that these data will be processed in accordance with the provisions of Regulation (EU) 2016/679 of 27 April 2016 (GDPR), for which you are provided with the following processing information:         ',
        processingOfPersonalDataText2:
          'Purposes of processing:          as specified in the section on cookies used on this website.',
        processingOfPersonalDataText3:
          'Legitimisation of the processing:          except in cases where it is necessary for browsing the website, by consent of the data subject (art. 6.1 RGPD).',
        processingOfPersonalDataText4:
          'Data retention criteria:          as specified in the section on cookies used on the website.',
        processingOfPersonalDataText5:
          'Communication of data:          data will not be communicated to third parties, except in cookies owned by third parties or by legal obligation.',
        processingOfPersonalDataTitle: 'PROCESSING OF PERSONAL DATA',
        rightsInterestedPartyText1: 'Right to withdraw consent at any time.',
        rightsInterestedPartyText2:
          'The right of access, rectification, portability and deletion of your data and the right to limit or oppose its processing.',
        rightsInterestedPartyText3:
          'Right to lodge a complaint with the Supervisory Authority',
        rightsInterestedPartyText4:
          'if you consider that the treatment does not comply with the regulations in force.',
        rightsInterestedPartyText5:
          'Contact details for exercising your rights:         ',
        rightsInterestedPartyTitle: 'Rights of the interested Party:         ',
        typeOfCookiesTitle: 'TYPE OF COOKIES',
        whatAreCookiesText1:
          'Cookies and other similar technologies such as local shared objects, flash cookies or pixels are tools used by web servers to store and retrieve information about their visitors and to provide a proper functioning of the site.',
        whatAreCookiesText2:
          'The use of these devices allows the web server to remember some data concerning the user, such as their preferences for viewing the pages of that server, name and password, products they are most interested in, etc.',
        whatAreCookiesTitle: 'WHAT ARE COOKIES?',
        whatCookiesDoWeUseText1:
          'Below is a more detailed explanation of each type of cookie, its purpose, type, temporality and ownership:         ',
        whatCookiesDoWeUseText10: 'Own',
        whatCookiesDoWeUseText11:
          'Use of Google Analytics cookies on websites:         ',
        whatCookiesDoWeUseText12: 'Google Analytics Privacy Terms:         ',
        whatCookiesDoWeUseText13: 'Google Cookie Terms:         ',
        whatCookiesDoWeUseText14: 'SOCIAL MEDIA COOKIES',
        whatCookiesDoWeUseText15:
          'In addition, this entity has a presence on third-party portals and services. You can find out about their privacy conditions and use of cookies by consulting the policies provided by them:         ',
        whatCookiesDoWeUseText2:
          'Other possible cookies to be loaded by Google´s visitor monitoring service.',
        whatCookiesDoWeUseText3: 'Purpose',
        whatCookiesDoWeUseText4:
          'Generate a unique user identifier, which is used to count how many times a user visits the Site, as well as the date of the first and last visit to the Site. Record the date and time of access to any of the pages of the Site. Check the need to keep a user´s session open or create a new one. Identify the user´s session, to collect the approximate geographic location of the computer accessing the Site for statistical purposes.',
        whatCookiesDoWeUseText5: 'Type',
        whatCookiesDoWeUseText6: 'Analytics',
        whatCookiesDoWeUseText7: 'Timeliness',
        whatCookiesDoWeUseText8: 'Permanent / Temporary',
        whatCookiesDoWeUseText9: 'Ownership',
        whatCookiesDoWeUseTitle: 'WHAT COOKIES DO WE USE AND FOR WHAT PURPOSE?',
      },

      history: {
        history:'History',
        patientHistory:'Patient History',
        medicalHistory:'Medical Data',
        explorerHistory:'Explorer',
        atlasHistory:'Atlas',
        loadingHistory: 'Loading...',
        loadingError: 'Error while loading',
        noData: 'No data'
      },

      country: 'Country',
      countryInvalid: 'Invalid country',
      countryInvalidCharacters: 'Invalid characters in the country',
      countryRequired: 'Country is required',
      deviceCode: 'Device code',
      deviceCodeInvalid: 'Device code is invalid',
      deviceCodeRequired: 'Device code is required',
      devices: 'Devices',
      dividerPrivateOrClinician: 'Professional or Private',
      email: 'Email (Non-modifiable)',
      emailInvalid: 'Invalid email',
      emailRequired: 'Email is required',
      getInstitutionName: 'Please enter the organization code to locate it...',
      goTooltipLogin: 'Go to login',
      goTooltipRecoverPassword: 'Go to reset password',
      institution: 'Organization Code',
      institutionInvalid: 'Organization is invalid',
      institutionName: 'Organization name',
      institutionRequired: 'Organization is required',
      intitutionNotFound:
        'Sorry, we could not find the organization with the code provided...',
      invalidCharactersName: 'Invalid characters in the name',
      invalidCharactersNationality: 'Invalid characters in the nationality',
      invalidCharactersSurnames: 'Invalid characters in the surnames',
      invalidName: 'Invalid name',
      invalidNationality: 'Invalid nationality',
      invalidSurnames: 'Invalid surnames',
      isClinic: 'I am a professional',
      isParticular: 'I am private',
      legalNotice: ' the legal notice',
      legalNoticeTexts: {
        address: 'Address:         ',
        applicableLawAndJurisdictionText:
          'The relationship between MARSI BIONICS S.L. and the user shall be governed by current Spanish legislation and any dispute shall be submitted to the Courts and Tribunals of the city of Rivas-Vaciamadrid.',
        applicableLawAndJurisdictionTitle:
          'APPLICABLE LAW AND JURISDICTION:         ',
        applicableLegislationText:
          'This Legal Notice is governed in each and every one of its aspects by Spanish law.',
        applicableLegislationTitle: 'APPLICABLE LEGISLATION:         ',
        book: 'Book:         ',
        cif: 'VAT NUMBER:         ',
        companyName: 'Company Name',
        date: 'Date:         ',
        domainName: 'Domain Name:         ',
        email: 'Email:         ',
        europeanPlatformText:
          'We inform you that in the event of any problem that may arise from the service contracted or product sold, you can use the European online dispute resolution platform:         ',
        europeanPlatformTitle:
          'EUROPEAN PLATFORM FOR ONLINE DISPUTE RESOLUTION:         ',
        exclusionWarrantiesText1:
          'MARSI BIONICS S.L. is not responsible, in any case, for the in any case, for damages of any kind that may be caused by, but not limited to may cause, by way of example:          errors or omissions in the contents, lack of content, lack of availability of the portal or the transmission of viruses or malicious transmission of viruses or malicious or damaging programmes in the content, in spite of having adopted all the necessary technological necessary technological measures to avoid this.',
        exclusionWarrantiesText2:
          'The content, information and / or advice expressed on this website should be understood as merely indicative. MARSI BIONICS S.L. is not responsible in any way for the effectiveness or accuracy of the same, being exempt from any liability to users who make use of them, as they are the ones who must decide at their discretion the timeliness of them. This Site may publish content and comments provided by third parties. MARSI BIONICS S.L. is not responsible for the veracity and accuracy of the same, being exempt from any liability to users who make use of them.',
        exclusionWarrantiesText3:
          'MARSI BIONICS S.L. reserves the right to modify the content of the Site without notice and without any limitation. Likewise, the company disclaims any liability for any damages that may be caused by the lack of availability and / or continuity of this site and the services offered on it. Likewise, we cannot guarantee the absence of viruses or other elements on the Website that may cause alterations to your computer system.',
        exclusionWarrantiesText4:
          'MARSI BIONICS S.L. disclaims any responsibility for the services and / or information provided on other sites linked to this one, as it does not control or exercise any supervision on third party websites. We advise users of these sites to act with prudence and to consult any legal conditions that may be set out on these websites. Likewise, users who send any information to MARSI BIONICS S.L. undertake to ensure that it is truthful and does not violate any third party rights or the law.',
        exclusionWarrantiesText5:
          'If you believe that any content and / or information on this site violates a legitimate right or the law, please contact MARSI BIONICS S.L. via email at',
        exclusionWarrantiesText6: 'so that we can take appropriate action.',
        exclusionWarrantiesTitle:
          'EXCLUSION OF WARRANTIES AND LIABILITY:         ',
        generalText:
          'MARSI BIONICS S.L. will pursue the breach of these conditions, as well as any improper use of its portal exercising all civil and criminal actions that may correspond to it by law.',
        generalTitle: 'GENERAL:         ',
        identificationData: 'IDENTIFICATION DATA:         ',
        intellectualPropertyText1:
          'MARSI BIONICS S.L, by itself or as an assignee, owns all intellectual and industrial property rights of its website, as well as the elements contained therein (including, but not limited to, images, sound, audio, video, software or texts; trademarks or logos, colour combinations, structure and design, selection of materials used, computer programs necessary for its operation, access and use, etc.), all rights reserved.',
        intellectualPropertyText2:
          'Pursuant to the provisions of Articles 8 and 32.1, second paragraph, of the second paragraph, of the Law on Intellectual Property, the reproduction, distribution and the reproduction, distribution and public communication, including the making available communication, including the making available, of all or part of the contents of this of all or part of the contents of this website, for commercial purposes, in any format and for any commercial purposes, in any medium and by any technical means, without the authorisation of MARSI BIONICS S.L. At no time, unless expressly stated otherwise, will the expressly stated otherwise, access, navigation or use of the website or its contents use of the website or its contents confers on the user any right over the distinctive signs included therein. The user undertakes to respect the Intellectual and Industrial Property rights Intellectual and Industrial property rights owned by MARSI BIONICS S.L. The unauthorised use of the unauthorised use of the information contained in this site, as well as any damage caused Site, as well as the damage caused to the rights of intellectual and industrial intellectual and industrial property rights of MARSI BIONICS S.L. may give rise to the the exercise of the corresponding legal actions and, if applicable, to the liabilities that may arise from such actions. arising from this exercise.',
        intellectualPropertyText3:
          'In the event that the user sends information of any kind to MARSI BIONICS S.L. through any of the channels provided for this purpose within our website, the user represents, warrants and agrees that he or she has the right to do so freely, that such information does not infringe any intellectual property rights, industrial, or any other rights of third parties, and that such information does not infringe any intellectual property rights, industrial, or any other rights of third parties, and that such information does not infringe any intellectual property rights. any other rights of third parties, and that such information is not of a information is not confidential or harmful to third parties. third parties.',
        intellectualPropertyTitle:
          'INTELLECTUAL AND INDUSTRIAL PROPERTY:         ',
        legalNoticeTitle: 'Legal Notice',
        modificationsText:
          'MARSI BIONICS S.L. reserves the right to make unannounced changes it deems appropriate in its website, may change, delete or add content and services provided through the same as the way in which they are presented or located on its website.',
        modificationsTitle: 'MODIFICATIONS:         ',
        page: 'Page:         ',
        phone: 'Phone:         ',
        registry: 'Registered in the Commercial Registry of:         ',
        rightOfExclusionText:
          'MARSI BIONICS S.L. reserves the right to deny or withdraw access to the portal and/or the services offered without prior notice, at its own request or at the request of a third party, to those users who do not comply with these General Conditions of Use.',
        rightOfExclusionTitle: 'RIGHT OF EXCLUSION:         ',
        section: 'Section:         ',
        sheet: 'Sheet:         ',
        text2IdentificationData: 'The owner of this site is:         ',
        textIdentificationData:
          'In compliance with the information duty established in Article 10 of Law 34/2002, of July 11, on Information Society Services and Electronic Commerce, the following data is provided below:         ',
        textLegalNotice:
          'The purpose of this document is to establish and regulate the rules for the use of this website, understanding by this all the pages and their content owned by MARSI BIONICS S.L. that can be accessed through the domain www.marsinet.com. The use of the website implies the condition of user of it and implies the acceptance of all the conditions included in this Legal Notice. The user agrees to carefully read this Legal Notice on each occasion they intend to use our website, as it and its conditions of use, as set forth in this Legal Notice, may undergo modifications.',
        tome: 'Volume:         ',
        usePortalText:
          'This portal provides access to an analysis of the data collected from the use of any of the collected following the use of any of the devices marketed by Marsi Bionics. The user assumes the responsibility for the use of the portal. This responsibility extends to the extends to the registration or collection of data that may be necessary to access certain access to certain services. When registering, the user will be responsible for providing truthful and lawful information.',
        usePortalTitle: 'USE OF THE PORTAL:         ',
        usersText:
          'The access and/or use of this web portal attributes the condition of USER, who accepts, from said access and/or use, the General Conditions of Use reflected herein. The aforementioned Conditions shall be applicable independently of the General Conditions of Contracting Contracting Conditions which, where applicable, are mandatory.',
        usersTitle: 'USERS:         ',
      },
      myHome: 'My home',
      myInstitution: 'My organization',
      myProfile: 'My account',
      name: 'Name',
      nameOrganizationInvalid: 'Invalid organization name',
      nameOrganizationInvalidCharacters:
        'Invalid characters in the organization name',
      nameOrganizationInvalidMarsi:
        'Invalid organization name, cannot contain "Marsi"',
      nameRequired: 'Name is required',
      nameTooShort: 'Name must be at least 2 characters',
      nationality: 'Nationality',
      nationalityRequired: 'Nationality is required',
      number: 'Number',
      o_id: 'Organization code',
      optional: 'Fields marked with this symbol are mandatory.',
      or: 'Or',
      organizationRequired: 'Organization is required',
      particular: 'Particular',
      password: 'Password',
      passwordLowercase: 'Must contain at least one lowercase letter',
      passwordMin: 'Password must be at least 8 characters',
      passwordMinLength: 'Password must be at least 8 characters',
      passwordNotCommon:
        'The password cannot be a common or easily guessable word',
      passwordNumber: 'Must contain at least one number',
      passwordRequired: 'Password is required',
      passwordSpecial: 'Must contain at least one special character',
      passwordUppercase: 'Must contain at least one uppercase letter',
      phone: 'Phone',
      phoneInvalid: 'Phone is invalid ( +12 34567890 )',
      phoneInvalidCharacters: 'Invalid characters in the phone',
      phoneRequired: 'Phone is required',
      pickPassword: 'Pick a password',
      postalCode: 'Postal code',
      postalCodeInvalid: 'Postal code is invalid',
      postalCodeRequired: 'Postal code is required',
      postal_codeInvalid: 'Invalid postal code',
      postal_codeInvalidCharacters: 'Invalid characters in the postal code',
      postal_codeRequired: 'Postal code is required',
      privacyPoliceTexts: {
        accuracyVeracityText:
          'As a user, you are solely responsible for the accuracy and correctness of the data you submit, exonerating MARSI BIONICS S.L. from any liability in this regard. Users guarantee and are responsible, in any case, for the accuracy, validity and authenticity of the personal data provided, and undertake to keep them duly updated.',
        accuracyVeracityTitle: 'ACCURACY AND VERACITY OF DATA',
        additionalInformationText1:
          'If you need additional information on data protection, you can send us an email to ',
        additionalInformationText2:
          ' or a communication addressed to Calle Marie Curie, 13, Edif. Bioma, Planta 6, Oficinas 1-2, CP 28521 Rivas-Vaciamadrid, Madrid and, depending on the type of relationship you have with our company and the processing of personal data that we carry out, we will provide you with the corresponding additional information.',
        additionalInformationTitle: 'ADDITIONAL INFORMATION ON DATA PROTECTION',
        address: 'Address:         ',
        changesPrivacyPoliceText:
          'MARSI BIONICS S.L. reserves the right to modify this policy to adapt it to new legislation or jurisprudence, as well as industry practices. In such cases, it will announce on this page the changes introduced reasonably in advance of their implementation.',
        changesPrivacyPoliceTitle: 'CHANGES IN THE PRIVACY POLICY',
        cif: 'VAT NUMBER:         ',
        companyName: 'Company Name',
        dataConfidentialityText1:
          'MARSI BIONICS S.L. undertakes to use and process the user´s personal data, respecting their confidentiality, in accordance with their purpose; as well as to comply with its obligation to store them and adopt all measures to prevent alteration, loss, unauthorised processing or access, in accordance with the provisions of current data protection regulations.',
        dataConfidentialityText2:
          'MARSI BIONICS S.L. cannot guarantee the absolute impregnability of the Internet, nor, therefore, the violation of data through fraudulent access to them by third parties. With regard to the confidentiality of processing, MARSI BIONICS S.L will ensure that any person who is authorised by MARSI BIONICS S.L to process customer data (including its staff, collaborators and service providers), is under an appropriate obligation of confidentiality (whether this is a contractual or legal duty).',
        dataConfidentialityTitle: 'DATA CONFIDENTIALITY AND SECURITY',
        dataProcessingText:
          'The processing, communication and transfer of personal data collected on this website shall comply with the provisions of the regulations on the protection of personal data, and in particular with Organic Law 3/2018, of 5 December, on the Protection of Personal Data and the guarantee of digital rights, and the current Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 on the protection of individuals with regard to the processing of personal data and on the free movement of such data and repealing Directive 95/46/EC.',
        dataProcessingTitle: 'Data processing',
        email: 'Email:         ',
        howLongWillWeProcessText1:
          'The personal data you provide us with will be kept for as long as the contractual / business relationship is in force, or for a period of four years from the last business relationship, in accordance with tax regulations.',
        howLongWillWeProcessText2:
          'Subsequently, the data will be deleted in accordance with the provisions of the data protection regulations, which implies its blocking, being available only at the request of Judges and Courts, the Public Prosecutor´s Office or the competent Public Administrations during the period of limitation of the actions that may arise and, after this period, it will be completely deleted.',
        howLongWillWeProcessText3:
          'You can always exercise your rights under current legislation by contacting us by the most convenient means for you, either by e-mail',
        howLongWillWeProcessText4:
          'or by telephone at 914 90 00 90 or at the postal address Marie Curie 13, Planta 6, Edif. Bioma, Oficinas 1-2, 28521 Rivas-Vaciamadrid, Madrid.',
        howLongWillWeProcessTitle: 'For how long will we process your data?',
        personalDataThirdPartiesText1:
          'In the event that the personal data provided belong to a third party, as a user you warrant that you have informed the third party of this Privacy Policy and have obtained their permission to provide their data to MARSI BIONICS S.L. for the purposes indicated.',
        personalDataThirdPartiesText2:
          'Likewise, you guarantee that the data provided are accurate and up to date, being responsible for any damage or loss, direct or indirect, that may be caused as a result of non-compliance with this obligation.',
        personalDataThirdPartiesTitle: 'PERSONAL DATA OF THIRD PARTIES',
        phone: 'Phone:         ',
        pivacyPoliceText:
          'In accordance with the provisions of EU Regulation 2016/679 of the European Parliament and of the Council of 27 April 2016 (GDPR) and Organic Law 3/2018 of 5 December on the Protection of Personal Data and guarantee of digital rights, MARSI BIONICS S. L, informs you that, by accepting this Privacy Policy, you give your express, informed, free and unequivocal consent for the data you provide, and on which the security, technical and organizational measures provided for in the current regulations are applied, to be processed by MARSI BIONICS S.L, as the data controller. The personal data that we may collect directly from the person concerned through www.marsinet.com will be treated confidentially and will be incorporated into the corresponding processing activity owned by MARSI BIONICS S.L.',
        pivacyPoliceTitle: 'PRIVACY POLICY',
        responsability:
          'Security Officer or Data Protection Officer, if applicable:         ',
        securityBreachNotificationText:
          'MARSI BIONICS S.L. takes security measures appropriate to the level of risk to protect personal information against loss, misuse and unauthorized access, disclosure, alteration and destruction, taking into account the risks involved in the processing and the nature of personal information; however, if MARSI BIONICS S. L. determines that the personal information it processes has been misappropriated, exposed by a security breach or improperly acquired by a third party, MARSI BIONICS S. L. will act immediately, taking into account the risks involved in the processing and the nature of the personal information. L determines that the personal data it processes has been misappropriated, exposed by a security breach or improperly acquired by a third party, MARSI BIONICS S.L will act immediately taking into account the provisions of the GDPR and the competent data protection authorities.',
        securityBreachNotificationTitle:
          'SECURITY BREACH NOTIFICATION AND DECLARATION',
        whatDataProcessText1:
          'Within the framework of the provision of the services offered by the entity and subject to the purposes consented to by you, our entity will only process the data strictly necessary for the correct management of the contractual relationship and/or provision of the services, and it will be exclusively the data that you have provided us with.',
        whatDataProcessText2: 'Data collected:         ',
        whatDataProcessText3:
          'Identification data:          name, surname, date of birth, nationality, company.',
        whatDataProcessText4:
          'Contact details:          postal address, e-mail address, mobile phone number, identity document.',
        whatDataProcessText5:
          'Physiological and health data:          sex, weight, height, pathology, treatment.',
        whatDataProcessText6:
          'Browsing data:          IP address, type and identification of the device, type of browser, domain through which you access the Website, browsing data, activity on the Website.',
        whatDataProcessText7:
          '* Plus data collected from the use of the device (number of steps, joint strength, joint range...).',
        whatDataProcessTitle: 'What data do we process?',
        whatLegitimateBasisText1:
          'The legal basis for the processing of your data is:         ',
        whatLegitimateBasisText2:
          'The execution of a contract with MARSI BIONICS S.L, for the procurement of services and / or products and manage the services requested.',
        whatLegitimateBasisText3:
          'The user´s consent in relation to contact, subscription to content and the sending of commercial communications, via email, cookies or messaging systems.',
        whatLegitimateBasisText4:
          'The legitimate interest of the data controller to protect users of the MARSI BIONICS S.L. website from abuse and fraud in the use of our services.',
        whatLegitimateBasisTitle:
          'What is the legitimate basis for processing your data?',
        whatPurposesDoWeProcessText1:
          'The personal data appearing on this website are extracted from any of the Marsi Bionics products and/or applications used by the user.',
        whatPurposesDoWeProcessText2:
          'The purpose of the processing of this data is to represent the results obtained after the use of the device or application. This data may be consulted by the user and/or by the clinical staff in charge of monitoring their data.',
        whatPurposesDoWeProcessText3:
          'MARSI BIONICS technical staff will have access to the device usage data to ensure that the device is properly maintained.',
        whatPurposesDoWeProcessTitle:
          'For what purposes do we process your personal data?',
        whatYoursRightsText1:
          'Any person has the right to obtain confirmation as to whether or not we are processing personal data concerning them. In this regard, you have the right to request:         ',
        whatYoursRightsText10:
          'It will be necessary to provide a photocopy of the DNI or equivalent document that proves identity and is considered valid in law, in those cases in which the data controller has doubts about the identity of the data subject.',
        whatYoursRightsText11:
          'If you wish to obtain additional information regarding the exercise of your rights, you may also contact the Spanish Data Protection Agency.',
        whatYoursRightsText12:
          'We also inform you that, if you consider it appropriate, you have the right to withdraw, at any time, the consent granted for any specific purpose, without affecting the lawfulness of the processing, based on the consent prior to its withdrawal. In the event that you understand that your rights have not been adequately addressed, you may file a complaint with the Spanish Data Protection Agency. C/ Jorge Juan, 6. 28001 - Madrid.',
        whatYoursRightsText2:
          'Access - The data subject shall have the right to obtain from the controller confirmation as to whether or not data relating to him/her are being processed, as well as detailed information about certain aspects of the processing being carried out.',
        whatYoursRightsText3:
          'Rectification - The data subject shall have the right to obtain the rectification of inaccurate personal data concerning him/her or the completion of incomplete personal data.',
        whatYoursRightsText4:
          'Deletion - The data subject shall have the right to request the deletion of his or her personal data; in any case, deletion shall be subject to the limits established in the regulatory rule.',
        whatYoursRightsText5:
          'Limitation of processing - The data subject shall have the right to request the limitation of the processing of his or her personal data.',
        whatYoursRightsText6:
          'Opposition to processing - In certain circumstances and for reasons related to their particular situation, data subjects may object to the processing of their data. The entity will stop processing the data, except for legitimate, compelling reasons, or the exercise or defence of possible claims.',
        whatYoursRightsText7:
          'Right to data portability - This means that you have the right to receive personal data relating to you, which you have provided to a controller, in a structured, commonly used and machine-readable format and to transfer it to another controller.',
        whatYoursRightsText8:
          'You may exercise the aforementioned rights by contacting the person responsible by e-mail at soporte.marsinet@marsibionics.com or by telephone on 914 90 00 90. Forms for the exercise of rights may also be submitted in person or sent by letter to the postal address Marie Curie 13, Planta 6, Edif. Bioma, Oficinas 1-2, 28521 Rivas-Vaciamadrid, Madrid.',
        whatYoursRightsText9:
          'In the case of acting through a legal representative, you must also provide your ID card and a document accrediting the representative´s representation.',
        whatYoursRightsTitle:
          'What are your rights when you provide us with your data?',
        whichRecipientsDataCommunicatedText1:
          'Please note that no international transfers will be made.',
        whichRecipientsDataCommunicatedText2:
          'The User is informed that, for the correct provision of services (see, web hosting, support, email marketing, etc.), different service providers contracted by our entity (data processors) may have access to the personal information necessary to carry out their functions.',
        whichRecipientsDataCommunicatedText3:
          'These services provided by third parties are necessary for the development of our activity and, at all times, the processing of data carried out by them is governed by a contract that binds the processor with respect to our entity. In no case will they use the information for other purposes and they will process it in accordance with the guidelines stipulated by our company, in accordance with its privacy policy and the regulations in force on data protection.',
        whichRecipientsDataCommunicatedText4:
          'Our entity, in its commitment to the privacy and data protection of the User, will only choose service providers that offer sufficient guarantees to apply appropriate technical and organizational measures, so that the processing is in accordance with the applicable legislation on data protection and guarantee the protection of the User´s rights.',
        whichRecipientsDataCommunicatedTitle:
          'To which recipients will your data be communicated?',
        whoDataControllerTitle: 'Who is the Data Controller of your data?',
      },
      prefix: 'prefix',
      province: 'Province',
      provinceRequired: 'Province is required',
      role: 'Role',
      roleRequired: 'Role is required',
      selectCountry: 'Select country',
      state: 'Province',
      stateRequired: 'State is required',
      streetNameRequired: 'Street name is required',
      streetNumberInvalid: 'Street number is invalid',
      streetNumberRequired: 'Street number is required',
      street_nameInvalid: 'Invalid street name',
      street_nameInvalidCharacters: 'Invalid characters in the street name',
      street_nameRequired: 'Street name is required',
      street_numberInvalid: 'Invalid street number',
      street_numberInvalidCharacters: 'Invalid characters in the street number',
      street_numberRequired: 'Street number is required',
      submit: 'Register',
      suggestion: 'Suggestion',
      suggestionLetterLower: 'At least one lowercase letter',
      suggestionLetterUpper: 'At least one uppercase letter',
      suggestionMinLength: 'At least 8 characters',
      suggestionNumber: 'At least one number',
      suggestionSpecial: 'At least one special character',
      surnames: 'Surnames',
      surnamesRequired: 'Surnames are required',
      surnamesTooShort: 'Surnames must be at least 2 characters',
      title: 'Register to Marsinet',
      tooltipIsClinic:
        'I am going to use the device in a clinical organization with more than one user.',
      tooltipIsParticular:
        'I am going to use the device individually, it will only be used by a single user.',
      user: 'User data',
      birthDateNotAdult: 'The user must be of legal age',
    },
    reports: {
      birthDate: 'Birth date',
      comments: 'Comments / Findings',
      createAt: 'Created at',
      description: 'Description',
      diagnostic: 'Diagnostic',
      firstUseDevice: 'First use of the device',
      followUpReport: 'Follow-up Report',
      goBack: 'Go back',
      graphs: {
        timeHour: 'Time (Hour)',
        fc: 'Heart rate',
        so2: 'Oxygen saturation',
        rom: 'ROM',
        stepsByMode: 'Total steps by mode',
        automaticBackward: 'Automatic backward',
        automaticForward: 'Automatic forward',
        backwardIntention: 'Backward triggering by force',
        forwardIntention: 'Forward triggering by force',
        ann1Forward: 'Aan1 forward',
        ann1Backward: 'Aan1 backward',
        ann2Forward: 'Aan2 forward',
        ann2Backward: 'Aan2 backward',
        activeMode: 'Active mode',
        activeModeForward: 'Active mode forward',
        activeModeBackward: 'Active mode backward',
        dailyEvolutionOfTheScore: 'Evolution of the score per day',
        dayAndMode: 'Steps per day and mode',
        days: 'Days',
        distributionStepsLastDay:
          'Distribution of the steps performed on the session',
        evolutionOfTheScore: 'Monthly evolution of the score',
        mobile:
          'The content of the graphs is not available in the mobile version, please access from a computer or a bigger device.',
        percentage: 'Percentage (%)',
        percentageAnalysis: 'Percentage analysis',
        score: 'Score',
        sessions: 'Sessions',
        steps: 'Steps',
        time: 'Minutes',
        totalSteps: 'Total number of steps',
        totalTime: 'Total amount of time',
        automaticForwardTime: 'No survey loaded',
      },
      identificationNumber: 'Identification number',
      lastSessionReceived: {
        score: 'was the total score for the session',
        standing: 'of time standing in the last session',
        steps: 'steps',
        time: 'of time using the device in the last session',
        timeMeasurement: 'minutes ',
        title: 'Last session received',
        totalSteps: 'In the last session he gave a number of',
        walking: 'of time walking in the last session',
      },
      lastUseDevice: 'Last use of the device',
      nameSurname: 'Name and surname',
      patientData: 'Patient data',
      performed: 'performed',
      romTitle: 'Range of motion (ROM)',
      saveToPdf: 'Save to PDF',
      score: 'Score',
      sessionSummary: 'Session summary',
      sessionsHeldInception: {
        score: 'was the historical total score',
        sessions: 'sessions',
        steps: 'steps taken from date',
        time: 'of time using the device during',
        timeMeasurement: 'minutes',
        title: 'Sessions held since inception',
      },
      sessionsLastMonth: {
        score: 'was the total monthly score',
        sessions: 'sessions',
        steps: 'steps taken to date day',
        theLastMonth: 'in the last month',
        time: 'of time using the device during',
        timeMeasurement: 'minutes',
        title: 'Sessions held in the last month',
      },
      signedBy: {
        certificate: 'Certificate number in ATLAS?',
        nameSurname: 'Name and surname',
        registrationNumber: 'Registration number',
      },
      steps: 'Steps',
      tables: {
        ankle: 'Ankle',
        anklel: 'Ankle left',
        ankler: 'Ankle right',
        automatic: 'Automatic',
        backward: 'Backward',
        cadence: 'Cadence',
        cadenceAutomatic: 'Cadence in automatic',
        cadenceIntention: 'Cadence in triggering by force',
        dungarees: 'Dungarees',
        effort: 'Effort',
        flexos: 'Flexos',
        forward: 'Forward',
        hip: 'Hip',
        hipl: 'Hip lefth',
        hipr: 'Hip right',
        history: 'Historical (averages)',
        index: 'Index',
        intention: 'Triggering by force',
        knee: 'Knee',
        kneel: 'Knee left',
        kneer: 'Knee right',
        lastMonth: 'Last month (averages)',
        lastSession: 'Last session',
        result: 'Result',
        stepsAutomatic: 'Steps in automatic',
        stepsIntention: 'Steps in triggering by force',
        tableComparativeOfLastSessionTitle:
          'Comparative table of the data of the last session with respect to the historical and last monthly data',
        therapist: 'Therapist',
        threshold: 'Threshold',
        titleLastSessions:
          'Table with the last sessions received by the patient',
        total: 'Total',
      },
      targets: 'Targets',
      time: 'Time',
      torqueTitle: 'Force per joint (Torque)',
      totalNumberofSessionsWithDevice:
        'Total number of sessions with the device',
      totalSteps: 'Steps distribution per mode and direction (%)',
      totalTime: 'Total time of use',
      yourResults: 'Your results since the beginning',
    },
    requestResetPassword: {
      back: 'Go to login',
      email: 'Email',
      emailInvalid: 'Invalid email',
      emailRequired: 'Email is required',
      emailSent: 'Email sent',
      emailSentError: 'Error sending email',
      emailSentSuccess: 'Email sent successfully',
      messageSent:
        'We have sent you the instructions to reset your password to your email address.',
      send: 'Send',
      title: 'Reset password',
    },
    sessions: {
      add: 'New session',
      eventsList: 'Events list',
      incidentList: 'Incident list',
      numberOfSteps: 'Number of steps',
      sessions: 'Sessions per device',
      table: {
        actions: 'Actions',
        date: 'Date',
        filters: {
          date: 'Date...',
          name: 'Name...',
          surnames: 'Surnames...',
        },
        name: 'Name',
        surnames: 'Surnames',
      },
      timeOfUse: 'Time of use',
      title: 'Sessions list',
    },
    users: {
      titlePassword: 'Reset password',
      resetPasswordConfirm:
        'A reset password email will be sent to {{email}}. Continue?',
      temporaryPassword: 'Temporary password',
      descriptionTemporaryPassword:
        'A temporary password will be generated for {{email}}. It will only be shown once. You must reset the password afterwards. Continue?',
      add: 'Create user',
      birthDate: 'Birth date',
      birth_date_required: 'Birth date is required',
      city: 'City',
      city_required: 'City is required',
      country: 'Country',
      country_required: 'Country is required',
      createUser: {
        birth_dateRequired: 'Birth date is required',
        cityRequired: 'City is required',
        countryRequired: 'Country is required',
        data: 'User data',
        device: 'Device',
        devices: 'Devices',
        emailInvalid: 'Email is invalid',
        emailRequired: 'Email is required',
        institution: 'Organization',
        nameRequired: 'Name is required',
        nationalityRequired: 'Nationality is required',
        organization_idRequired: 'Organization code is required',
        passwordRequired: 'Password is required',
        phoneRequired: 'Phone is required',
        postal_codeRequired: 'Postal code is required',
        roleRequired: 'Type of User is required',
        stateRequired: 'Province is required',
        street_nameRequired: 'Address is required',
        street_numberRequired: 'Number is required',
        surnamesRequired: 'Surnames is required',
        type: 'Select Type of User',
        type_device_required: 'Type of User is required',
      },
      delete: 'Delete',
      deleteConfirm: 'Would you like to delete the user?',
      deleteConfirmTitle: 'Delete confirmation',
      deleteError: 'Error deleting user',
      cannotDeletePendingUser: 'You cannot delete a user with PENDING STATUS',
      deleteForbidden: "You don't have permission to delete this user",
      deleteConflict: 'This user is registered as the creator of an organization. Please assign another creator to that organization before deleting',
      deleteSuccess: 'User deleted successfully',
      details: 'Details',
      dividerAddress: 'Address',
      dividerAdmin: 'Administrator data',
      dividerClinic: 'Organization data',
      dividerDevice: 'Device data (optional)',
      doAdmin: 'Do administrator',
      doAdminConfirm:
        'Are you sure you want to make the user an administrator?',
      doAdminConfirmTitle: 'Administrator Confirmation',
      doAdminError: 'Error creating administrator',
      doAdminSuccess: 'Administrator created successfully',
      removeAdmin: 'Remove administrator',
      removeAdminConfirm:
        'Are you sure you want to remove administrator permissions?',
      removeAdminConfirmTitle: 'Remove administrator confirmation',
      removeAdminError: 'Error removing administrator permissions',
      removeAdminSuccess: 'Administrator permissions removed successfully',
      edit: {
        edit: 'Edit',
        title: 'Edit user',
      },
      email: 'Email',
      email_administrator_clinic_invalid: 'Email is invalid',
      email_administrator_clinic_required: 'Email is required',
      messages: {
        delete: 'User deleted',
        deleteConfirm: 'Would you like to delete the user?',
        deleteConfirmTitle: 'Delete confirmation',
        deleteError: 'Error deleting user',
        deleteSuccess: 'User deleted successfully',
      },
      name: 'Name administrator',
      nameOrganization: 'Name of the organization',
      name_administrator_clinic_required: 'Name is required',
      name_organization_required: 'Name of the organization is required',
      nationality: 'Nationality',
      nationality_required: 'Nationality is required',
      password: 'Password',
      password_administrator_clinic_required: 'Password is required',
      phone: 'Phone',
      phone_administrator_clinic_required: 'Phone is required',
      postalCode: 'Postal code',
      postal_code_required: 'Postal code is required',
      selectCountry: 'Select country',
      state: 'Province',
      state_required: 'Province is required',
      streetName: 'Address',
      streetNumber: 'Number',
      street_name_required: 'Address is required',
      street_number_required: 'Number is required',
      surnames: 'Surnames administrator',
      surnames_administrator_clinic_required: 'Surnames is required',
      table: {
        activate: 'Are you sure you want to activate the user?',
        active: 'Active',
        adminRole: 'Administrator role',
        deactivateTitle: 'Deactivate user',
        activateTitle: 'Activate user',
        desactivate: 'Are you sure you want to deactivate the user?',
        email: 'Email',
        pending: 'Pending verification',
        filters: {
          active: 'Active...',
          email: 'Email...',
          institution: 'Organization...',
          lastName: 'Last name...',
          name: 'First name...',
          role: 'Role',
          apply: 'Apply'
        },
        institution: 'Organization',
        lastName: 'Last name',
        name: 'First name',
        particular: 'Individual',
        professional: 'Professional',
        type: 'Type',
        usersActive: 'Active users',
        usersInactive: 'Inactive users',
        usersUnverified: 'Unverified users'
      },
      title: 'Users list',
      type: 'Type of user',
      cannotRemoveOwnAdmin: 'You cannot remove the administrator role from yourself',
      cannotDeleteSelf: 'You cannot delete your own account',
      missingIdentifier: 'Tester',
      deleteErrorUserNotFound: 'Distributor',
      deleteErrorUser: 'Save',
    },
    requestDeleteAccount: {
      title: 'DATA DELETION REQUEST',
      detailsText1:
        'This page explains how to submit a request for the deletion of accounts or personal data for existing users of the application',
      detailsText2: ' developed by ',
      additionalInformationText1:
        'For any additional information, you can consult ',
      additionalInformationText2: ' or send a support email to ',
      procedure: {
        title: 'PROCEDURE',
        step1Text1: 'To proceed with the request, you must send an email to',
        step1Text2: 'indicating which data you would like to delete',
        step2Text1:
          'Our team will review your request and respond within a maximum period of',
        step2Text2: '30 business days',
        warning:
          'You must ensure that the data you wish to delete is linked to the email address used to send the request. Otherwise, the request will be denied.',
      },
    },
    main_panel: {
      created_by: 'Created by',
      patients: 'Patients',
      devices: 'Devices',
      device: 'Device',
      role: 'Role',
      no_devices: 'No devices',
      users: 'Users',
      no_users: 'No users',
      filter_device: 'Filter by device',
      filter_role: 'Filter by role',
      expand_all: 'Expand all',
      collapse: 'Collapse all',
      reset_view: 'Reset view',
      show_creators: 'Show creators',
      show_role_groups: 'Show role groups',
      filter_organization: 'Go to organization',
      filter_user: 'Go to user',
      col_view: 'Visualization options',
      col_filters: 'Filtering options',
      col_navigate: 'Navigation options',
      admins: 'Admins',
      regular_users: 'Active',
      inactive_users: 'Inactive',
      view_device: 'View device',
      view_organization: 'View organization',
      filter: 'Filter data',
      by_device: 'Filter by device',
      by_organization: 'Filter by organization',
      search: 'Search',
      clear: 'Clear',
      organizations: 'Organizations',
      no_devices_found: 'No devices',
      no_organizations_found: 'No organizations',
    },
  },
  roles: {
    clinic: 'Clinic',
    commercial: 'Commercial',
    maintenance: 'Maintenance',
    marsi: 'Admin Marsi',
    personal: 'Personal',
    tester: 'Tester',
    distributor: 'Distributor',
    specialist_clinic: 'Specialist clinic',
    all_roles: 'All roles',
  },
  status: {
    active: 'Active',
    paused: 'Paused',
  },
  save: 'Save',
  cancel: 'Cancel',
  selectDate: 'Select date',
  selectDevice: 'Select device',
  selectInstitution: 'Fill with your organization code',
  selectOneDevice:
    'Please select a device from the list to view its details....',
  selectTimezone: 'Select Timezone',
  sessionLastMonth: 'Last month sessions',
  steps: 'Steps',
  timeOfUse: 'Time of use',
  verifyEmail:
    'Please verify your email address in order to activate your account.',
  yes: 'Yes',
  totalPatients: 'Total patients of your organization',
  totalSessions: 'Total sessions',
  totalStepsOfMode: 'Total steps of mode',
  monthlyEvolution: 'Monthly evolution',
  stepsPerMonth1: 'Steps per month: ',
  stepsPerMonth2: ' (Long-term patient physical activity trend) .',
  serverErrorTitle: 'Server error',
  serverErrorDescription: 'Server error, please try again later',
  loadingRanking: 'Loading ranking...',
  loadingDataPleaseWait: 'We are retrieving the data for the selected device.',
  couldNotLoadRanking: 'The ranking could not be loaded',
  errorLoadingData: 'There was a problem retrieving the data.',
  lastMonth: 'Last month',
  lastTrimester: 'Last trimester',
  lastSemester: 'Last semester',
  lastYear: 'Last year',
  noRankingDataAllDevicesTitle: 'No data to display yet',
  noRankingDataAllDevicesDescription:
    'No steps were recorded during the last month for the available devices.',
  noRankingDataDeviceTitle: 'This device has no recent activity',
  noRankingDataDeviceDescription:
    'No steps were recorded during the last month for device {{device}}.',
  common: {
    success: 'Success',
    error: 'Error',
    validation: 'Validation',
    cancel: 'Cancel',
    clear: 'Clear',
    name: 'Name',
    color: 'Color',
    description: 'Description',
    stats: 'Stats',
    actions: 'Actions',
    selected: 'Selected',
    access_denied: 'Access denied',
    no_permission: "You don't have permission to access this feature.",
    videos: 'Training Videos',
    total_videos: 'Total videos: {{total}}',
    error_loading_videos: 'Error loading videos',
    no_videos: 'No videos available yet',
    default_video_title: 'Training video ({{number}})',
    play_video: 'Play {{title}}',
    video_name: 'Video: {{name}}',
    tag_label: 'Tag:',
    edit_tags: 'Edit tags',
    add_tag: 'Add tag',
    add_tag_subscription: 'Add tag / Subscription',
    tags_management: 'Tags management',
    tag_data: 'Create tag',
    edit_tag: 'Edit tag',
    tag_name: 'Tag name',
    tag_name_placeholder: 'App, Marsinet, etc.',
    tag_description_placeholder: 'Enter the tag description',
    subscribed_organizations: 'Subscribed organizations',
    organizations_selected_count: '{{selected}} organization(s) selected',
    save_tag: 'Save tag',
    update_tag: 'Update tag',
    existing_tags: 'Existing tags ({{total}})',
    no_tags_created: 'No tags created yet',
    tag_name_required: 'Tag name is required',
    tag_description_required: 'Description is required',
    tag_created: 'Tag "{{name}}" created successfully',
    tag_updated: 'Tag updated successfully',
    tag_deleted: 'Tag "{{name}}" deleted successfully',
    error_loading_tags: 'Error loading tags',
    error_creating_tag: 'Error creating tag',
    error_updating_tag: 'Error updating tag',
    error_deleting_tag: 'Error deleting tag',
    confirm_delete: 'Confirm delete',
    confirm_delete_tag:
      'Are you sure you want to delete the tag "{{name}}"? It will also be removed from {{videos}} video(s) and {{organizations}} organization(s) will be unsubscribed. This action cannot be undone.',
    videos_count_label: 'Videos:',
    organizations_count_label: 'Orgs:',
    subscriptions_management: 'Subscriptions management',
    subscriptions_help:
      'Select the organizations and the tags you want to subscribe them to. Videos with these tags will be automatically available to the users of those organizations.',
    organizations_count: 'Organizations ({{total}})',
    no_organizations_available: 'No organizations available.',
    select_organizations: 'Select organizations...',
    select_organizations_to_subscribe: 'Select organizations to subscribe',
    selected_organizations: 'Selected organizations',
    tags_count: 'Tags ({{total}})',
    no_tags_available_yet: 'No tags available yet.',
    select_tags_to_subscribe: 'Select tags to subscribe',
    selected_tags: 'Selected tags',
    subscribe_organizations: 'Subscribe organizations',
    select_at_least_one_organization: 'Please select at least one organization',
    select_at_least_one_tag: 'Please select at least one tag',
    organizations_subscribed:
      '{{organizations}} organization(s) subscribed to {{tags}} tag(s) successfully',
    error_updating_subscriptions: 'Error updating subscriptions',
    error_loading_organizations: 'Error loading organizations',
    no_permission_manage_tags:
      'You do not have permission to manage tag subscriptions',
    video_tags: 'Video tags',
    edit_video_tags_title: 'Video tags editing',
    edit_video_tags_help:
      'Select the tags you want to associate with this video. You can select several tags from the available list. If you do not select any tag, the video will have no tags associated.',
    select_tags_for_video_help:
      'Select the tags you want to assign to this video',
    available_tags: 'Available tags ({{total}})',
    no_tags_available: 'No tags available. Create some tags first.',
    select_tags_for_video: 'Select tags for this video',
    tags_selected_count: '{{selected}} tag(s) selected',
    no_tags_selected: 'No tags selected. This video will have no tags.',
    save_tags: 'Save tags',
    video_tags_updated: 'Tags updated successfully for this video',
    video_tags_removed: 'Tags removed successfully for this video',
    error_updating_video_tags: 'Error updating tags for this video',
  },
  errors: {
    userNotFound: 'User not found.',
    userNotInAllowedOrg: 'You do not belong to any allowed organization.',
    adminNotFound: 'No admin user found for this organization.',
    errorRemovingAdminRole: 'Error removing administrator role from user.',
    cannotRemoveLastAdmin:
      'Cannot remove the last administrator from the organization.',
    unknown: 'An unexpected error occurred',
  },
  view_details: 'View details',
  controlErrors: {
    controlErrors: {
      UNKNOWN_ERROR: 'An unknown error has occurred.',
      VALIDATION_ERROR: 'The provided data is invalid.',
      UNAUTHORIZED: 'You must log in to perform this operation.',
      FORBIDDEN: 'You do not have permission to perform this operation.',
      NOT_FOUND: 'The requested resource was not found.',
      CONFLICT: 'The operation cannot be completed due to a conflict.',
      AUTH_TOKEN_INVALID: 'The authentication token is invalid.',
      AUTH_TOKEN_EXPIRED: 'Your session has expired. Please log in again.',
      AUTHENTICATION_FAILED:
        'Authentication could not be completed. Please check your credentials.',
      AUTH_INSUFFICIENT_PERMISSIONS:
        'You do not have sufficient permissions to perform this operation.',
      AUTH_CURRENT_PASSWORD_INCORRECT: 'The current password is incorrect.',
      AUTH_PENDING_EMAIL_VERIFICATION: 'You must verify your email address before logging in.',
      AUTH_PENDING_ADMIN_ACTIVATION: 'Your account is awaiting activation by an administrator.',
      AUTH_TOKEN_WRONG_TYPE: 'The provided authentication token is not of the expected type.',
      LOGIN_ATTEMPTS_EXCEEDED: 'You have exceeded the maximum number of login attempts.',
      LOGIN_COOLDOWN_REQUIRED: 'You must wait before attempting to log in again.',
      LOGIN_IP_BLOCKED: 'Login is temporarily blocked for this IP address.',
      LOGIN_PERMANENT_BLOCK_REQUIRED: 'The account has been locked due to too many failed login attempts.',
      VALIDATION_REQUIRED_FIELD: 'You have required fields that must be completed.',
      VALIDATION_EMPTY_FIELD: 'This field cannot be empty.',
      VALIDATION_INVALID_FORMAT: 'The entered format is invalid.',
      VALIDATION_INVALID_FORMAT_NUMBER:
        'The value must contain at least one number.',
      VALIDATION_BIRTH_DATE_INVALID: 'The date of birth is invalid.',
      VALIDATION_BIRTH_DATE_UNDERAGE:
        'The date of birth does not meet the minimum age requirement.',
      VALIDATION_INVALID_ORGANIZATION:
        'The selected organization is invalid.',
      VALIDATION_DUPLICATE_VALUE: 'This value is already registered.',
      VALIDATION_INVALID_FORMAT_LOWERCASE:
        'The value must contain at least one lowercase letter.',
      VALIDATION_INVALID_FORMAT_UPPERCASE:
        'The value must contain at least one uppercase letter.',
      VALIDATION_PASSWORD_MISMATCH: 'The passwords do not match.',
      VALIDATION_PASSWORD_REUSED:
        'The new password must be different from the current password.',
      VALIDATION_RESET_TOKEN_INVALID:
        'Invalid or expired token. Please request a new password reset link.',
      VALIDATION_OTT_EXPIRED: 'The OTT is invalid or has expired.',
      //Ingestion related errors
      VALIDATION_ACCESS_DENIED: 'You do not have permission to access this resource. Resource not found.',
      VALIDATION_MALFORMED: 'The file is malformed.',
      VALIDATION_MODEL_NOTFOUND: 'The specified model was not found.',
      VALIDATION_INVALID_TYPE: 'The specified type is invalid.',
      VALIDATION_ERROR_PROCESSING: 'An error occurred while processing the ZIP ingestion.',
      VALIDATION_BAD_REQUEST: 'The request is invalid.',
      VALIDATION_PAYLOAD_TOO_LARGE: 'The payload is too large.',
      VALIDATION_UNSUPPORTED_MEDIA_TYPE: 'The media type is not supported.',
      SYNC_PATIENT_VERSION_TOO_LOW: 'The patient version is too low.',
      SYNC_ERROR_DELETING_PATIENT: 'An error occurred while deleting the patient.',
      SYNC_NOT_IN_ORG: 'The patient does not belong to your organization.',
      BUSINESS_ERROR_DELETING_PATIENT: 'An error occurred while deleting the patient.',
      BUSINESS_USER_NOT_FOUND: 'The user was not found.',
      BUSINESS_DEVICE_NOT_FOUND: 'The device was not found.',
      BUSINESS_INGESTION_NOT_FOUND: 'The ingestion was not found.',
      BUSINESS_MAINTENANCE_ORDER_NOT_FOUND: 'The maintenance order was not found.',
      BUSINESS_UNAUTHORIZED_ADMIN_UPDATE_ORGANIZATION: 'You do not have permission to modify the organization assigned to this administrator.',
      BUSINESS_ERROR_UPDATING_ORGANIZATION: 'An error occurred while updating the organization.',
      BUSINESS_DEVICE_NOT_FOUND_IN_ORGANIZATION: 'The device was not found in the organization.',
      BUSINESS_ORGANIZATION_NOT_FOUND: 'The organization was not found.',
      BUSINESS_DEVICE_ALREADY_ASSIGNED_TO_ORGANIZATION:
        'The device is already assigned to an organization.',
      BUSINESS_DEVICE_NOT_LINKED_TO_ORGANIZATION:
        'The device is not linked to the organization.',
      BUSINESS_DEVICE_MODEL_NOT_FOUND:
        'The device model was not found.',
      BUSINESS_CONFLICT_ON_DELETE_USER:
        'The user cannot be deleted because they have associated information or relationships.',
      BUSINESS_DEVICE_SERIAL_EXISTS:
        'A device with this serial number already exists.',
      BUSINESS_CONFLICT_ON_DELETE_DEVICE:
        'The device cannot be deleted because it has associated data.',
      BUSINESS_USER_ALREADY_ACTIVE: 'The user is already active.',
      BUSINESS_ADMIN_NOT_FOUND_FOR_ORGANIZATION: 'No administrator was found for the organization.',
      BUSINESS_CANNOT_REMOVE_LAST_ADMIN: 'The last administrator of the organization cannot be removed.',
      BUSINESS_ERROR_REMOVING_ADMIN_ROLE: 'An error occurred while removing the administrator role.',
      BUSINESS_USER_NOT_IN_ALLOWED_ORG: 'The user does not belong to any authorized organization.',
      BUSINESS_INVALID_CREATOR: 'This user cannot be designated as the creator of this organization.',
      BUSINESS_CONFLICT_ON_DELETE_ORGANIZATION: 'The organization cannot be deleted because dependent records are currently being imported.',
      BUSINESS_NOT_CONFIG_PRIVACY_SETTINGS: 'The privacy settings are not configured correctly.',
      BUSINESS_ERROR_PRIVACY_SETTINGS: 'An error occurred while updating the privacy settings.',
      BUSINESS_USER_ALREADY_ADMIN: 'The user is already an administrator.',
      BUSINESS_ONLY_MARSI: 'Only users with the Marsi role can perform this action.',
      BUSINESS_SESSION_NOT_FOUND: 'The session was not found.',
      VALIDATION_INVALID_FIELDS: 'The provided fields are invalid.',
      EXTERNAL_API_ERROR: 'An error occurred while communicating with an external service.',
      EXTERNAL_API_TIMEOUT: 'The external service took too long to respond.',
      DATABASE_CONNECTION_ERROR: 'Could not establish a connection to the database.',
      NETWORK_TIMEOUT: 'The request has timed out.',
      NETWORK_ERROR:
        'A network error occurred. Please check your connection and try again.',
      SYSTEM_INTERNAL_ERROR: 'An internal system error has occurred.',
      SYNC_PATIENTS_UPLOAD_FAILED: 'Local patients could not be synchronized with the server.',
      SYNC_PATIENTS_DOWNLOAD_FAILED: 'Patients could not be downloaded from the server.',
      SYNC_DEVICES_DOWNLOAD_FAILED: 'Devices could not be downloaded from the server.',
      SYNC_SESSIONS_UPLOAD_FAILED: 'Pending sessions could not be uploaded.',
      BUSINESS_DASHBOARD_ALREADY_EXISTS: 'A dashboard with the same name already exists in the organization.',
      BUSINESS_CONFLICT_ON_DELETE_DASHBOARD: 'The dashboard cannot be deleted because dependent records exist.',
      BUSINESS_DASHBOARD_NOT_FOUND: 'The dashboard was not found.',
      BUSINESS_PATIENT_NOT_FOUND: 'The patient was not found.',
      //RPS
      RPS_UNAVAILABLE: 'RPS is temporarily unavailable. Please try again later.',
      RPS_ERROR: 'An error occurred while communicating with RPS.',
      RPS_COMPONENT_OUT_OF_SERVICE: 'The component is out of service and this operation cannot be performed.',
      RPS_EMAIL_NOT_FOUND: 'No user was found with this email address.',
      RPS_NOT_COMPONENT: 'No component was found for serial number ${serial}.',
      RPS_NOT_FOUND: 'The requested incident was not found.',
      RPS_NOT_CLOSED: 'The incident cannot be closed because it has unfinished maintenance orders.',
      RPS_IDENTIFIER_REQUIRED: 'An identifier is required.',
      RPS_FIELDS_INVALID: 'Invalid data.',
      RPS_NOT_COMPONENT_ASSOCIATED: 'The incident/maintenance order has no associated component.',
      RPS_OTHER_TEAM: 'The incident belongs to another team and cannot be processed.',
      RPS_INVALID_OM_CLOSED: 'The maintenance order cannot be closed because it is already closed and does not allow status changes.',
      RPS_OM_CANT_CLOSED: 'To complete the maintenance order, you must use the closure process instead of changing its status.',
      RPS_OM_NOT_STATUS: 'The maintenance order is not in the required status for this operation.',
      //OTA
      BUSINESS_OTA_BAD_REQUEST: 'The file integrity check failed. The checksum does not match. The file may have been corrupted during upload.',
      BUSINESS_OTA_NOT_VALID: 'Invalid software type. Valid values: 0 (CM7), 1 (CM4), 2 (ESP).',
      BUSINESS_OTA_UPLOAD_FAILED: 'The firmware upload failed due to an internal server error.',
      BUSINESS_OTA_METADATA_INVALID: 'Invalid firmware metadata.',
      BUSINESS_OTA_NAME_INVALID: 'Invalid firmware name.',
      BUSINESS_OTA_EXISTS_VERSION: 'This version already exists for the software type. Please use a different version.',
      BUSINESS_OTA_NEW_VERSION: 'A new firmware version has been detected. Please update to the latest version.',
      BUSINESS_OTA_NOT_FOUND: 'The requested firmware was not found.',
      BUSINESS_OTA_RANGE_INVALID: 'The firmware download range is invalid.',
      //SURVEYS
      BUSINESS_NOT_FOUND: 'The requested data was not found.',
      BUSINESS_USER_NOT_SUBSCRIBED: 'The user is not subscribed to the requested survey.',
      RPS_USER_NOT_FOUND: 'No RPS user is associated with this email address.',
      RPS_EMPLOYEE_NOT_FOUND: 'No RPS employee is associated with this email address.',
      RPS_COMPONENT_NOT_FOUND: 'The component was not found in RPS.',
      RPS_USER_REQUIRED_CODE: 'The user code is required.',
      RPS_INCIDENCE_NOT_FOUND: 'No incident was found with the specified identifier.',
      RPS_OM_NOT_MATCH: 'The maintenance order is not associated with the incident.',
      RPS_SOLUTION_NOT_FOUND: 'RPS did not return the incident or maintenance order code.',
    }
  },
};
export default en;
